{
  "booking": {
    "title": "Резервации",
    "description": "Управлявайте и потвърждавайте резервации. Потвърдените резервации ще се покажат в календара по-долу.",
    "stats": {
      "totalBookings": "Общо резервации",
      "pending": "Изчакващи",
      "confirmed": "Потвърдени",
      "upcomingToday": "Предстоящи днес"
    },
    "table": {
      "booking": "Резервация",
      "customer": "Клиент",
      "resource": "Ресурс",
      "dateTime": "Дата и час",
      "status": "Статус",
      "actions": "Действия",
      "party": "Група: {{size}}"
    },
    "actions": {
      "confirmBooking": "Потвърди резервация",
      "confirm": "Потвърди",
      "rescheduleWithAI": "Пренасрочване с AI агент",
      "aiReschedule": "AI пренасрочване",
      "cancelBooking": "Отмени резервация",
      "cancel": "Отмени"
    },
    "unconfirmed": {
      "title": "Непотвърдени резервации",
      "searchPlaceholder": "Търсене на резервации...",
      "filterPending": "Изчакващи",
      "filterAll": "Всички",
      "pagination": "{{start}}-{{end}} от {{total}} резервации"
    },
    "calendar": {
      "title": "Потвърдени резервации – Календар",
      "hint": "Кликнете върху резервация, за да видите детайли"
    },
    "details": {
      "title": "Детайли за резервация",
      "description": "Описание:",
      "customer": "Клиент:",
      "dateTime": "Дата и час:"
    },
    "messages": {
      "confirmSuccess": "Резервацията е потвърдена успешно!",
      "confirmError": "Неуспешно потвърждаване на резервация",
      "cancelTitle": "Отмяна на резервация",
      "cancelContent": "Сигурни ли сте, че искате да отмените тази резервация?",
      "cancelOk": "Да, отмени",
      "cancelNo": "Не",
      "cancelSuccess": "Резервацията е отменена успешно!",
      "cancelError": "Неуспешна отмяна на резервация"
    }
  },
  "calendar": {
    "messages": {
      "confirmTitle": "Потвърждаване на среща",
      "confirmContent": "Сигурни ли сте, че искате да потвърдите тази среща{{name}} на {{date}}?",
      "confirmOk": "Да, потвърди",
      "confirmSuccess": "Срещата е потвърдена успешно",
      "confirmError": "Неуспешно потвърждаване на среща",
      "cancelTitle": "Отмяна на среща",
      "cancelContent": "Сигурни ли сте, че искате да отмените тази среща{{name}} на {{date}}?",
      "cancelOk": "Да, отмени",
      "cancelSuccess": "Срещата е отменена успешно",
      "cancelError": "Неуспешна отмяна на среща",
      "deleteTitle": "Изтриване на среща",
      "deleteContent": "Сигурни ли сте, че искате да изтриете тази среща{{name}} на {{date}}? Това действие не може да бъде отменено.",
      "deleteOk": "Да, изтрий",
      "deleteSuccess": "Срещата е изтрита успешно",
      "deleteError": "Неуспешно изтриване на среща",
      "noShowTitle": "Маркирай като неявяване",
      "noShowContent": "Маркирате ли тази среща{{name}} на {{date}} като неявяване на клиент?",
      "noShowOk": "Да, маркирай неявяване",
      "noShowSuccess": "Срещата е маркирана като неявяване",
      "noShowError": "Неуспешно маркиране на срещата като неявяване",
      "withClient": " с {{name}}"
    }
  },
  "appointmentComponents": {
    "calendarHeader": {
      "title": "Календар",
      "description": "Преглед и управление на срещите и резервациите.",
      "createAppointment": "Добави среща"
    },
    "stats": {
      "totalAppointments": "Общо срещи",
      "scheduled": "Планирани",
      "confirmed": "Потвърдени",
      "upcomingToday": "Предстоящи днес"
    },
    "filters": {
      "title": "Филтри",
      "status": "Статус",
      "allStatuses": "Всички статуси",
      "user": "Потребител",
      "allUsers": "Всички потребители",
      "resource": "Ресурс",
      "allResources": "Всички ресурси",
      "clearFilters": "Изчисти филтрите",
      "actions": "Действия",
      "apptCount": "{{count}} среща",
      "apptCount_plural": "{{count}} срещи",
      "showExternalCalendars": "Покажи външни календари",
      "loadingExternalEvents": "Зареждане на външни календарни събития…",
      "noResources": "Няма налични ресурси. Добавете ресурс, за да видите календара.",
      "statusLabels": {
        "SCHEDULED": "Насрочен",
        "CONFIRMED": "Потвърден",
        "PENDING": "Изчакващ",
        "IN_PROGRESS": "В процес",
        "CANCELLED": "Отменен",
        "COMPLETED": "Завършен",
        "NO_SHOW": "Неявяване",
        "SHADOW": "Сянка"
      }
    },
    "calendar": {
      "appointment": {
        "hiddenSuffix": "· скрит",
        "clientPending": "изчаква",
        "fallbackTitle": "Среща"
      }
    },
    "externalEvent": {
      "notAvailable": "н/д",
      "unavailable": "недостъпен",
      "readOnly": "Импортирано събитие от календар (само за четене)",
      "details": {
        "title": "Външно събитие от календар",
        "summary": "Заглавие",
        "location": "Местоположение",
        "resource": "Ресурс",
        "dateTime": "Дата и час",
        "ends": "Приключва в {{time}}",
        "readOnly": "Импортирано (само за четене)",
        "noSummary": "Без заглавие"
      }
    },
    "conflictAlert": {
      "title": "Открит е конфликт при планиране",
      "description": "Външно събитие от календар ({{externalLabel}}, {{timeRange}}) се припокрива със съществуваща SA среща ({{appointmentName}}) в {{weekday}}, {{date}}. Съществуващата среща не е отменена — необходимо е ръчно разрешаване.",
      "summary": "Открити са {{count}} конфликта при планиране между импортирани събития от календар и SA срещи:",
      "item": "{{externalLabel}} ({{timeRange}}) се припокрива със {{appointmentName}} в {{weekday}}, {{date}}.",
      "footer": "Съществуващите срещи не са отменени — необходимо е ръчно разрешаване."
    },
    "conflictDayBadge": "Конфликт",
    "legend": {
      "title": "Легенда на статусите:",
      "scheduled": "Планирана (Непотвърдена)",
      "confirmed": "Потвърдена",
      "pending": "Чакащ",
      "inProgress": "В процес",
      "completed": "Завършена",
      "cancelled": "Отказана",
      "noShow": "Неявяване",
      "externalBlocked": "Външен / Блокиран"
    },
    "jumpToDate": "Към дата:",
    "addAppointmentOnDay": "Добави среща",
    "resourceFallback": "Ресурс {{id}}",
    "changeRequest": {
      "pendingPanelEmpty": "Няма чакащи клиентски заявки за промяна",
      "pendingHeaderButton": "Чакащи заявки",
      "pendingDrawerTitle": "Чакащи заявки за промяна",
      "review": "Преглед",
      "reviewTitle": "Преглед на заявка за промяна",
      "customer": "Клиент",
      "requestType": "Тип заявка",
      "typeReschedule": "Преместване на среща",
      "status": "Статус",
      "originalTime": "Първоначална среща",
      "requestedTime": "Заявен час",
      "customerNote": "Бележка от клиента",
      "internalRejectNote": "Вътрешна бележка при отказ",
      "internalRejectNoteHint": "Видима само за персонала",
      "approve": "Одобри",
      "reject": "Отхвърли",
      "approvedSuccess": "Заявката за промяна е одобрена.",
      "rejectedSuccess": "Заявката за промяна е отхвърлена.",
      "approveFailed": "Заявката за промяна не можа да бъде одобрена.",
      "rejectFailed": "Заявката за промяна не можа да бъде отхвърлена.",
      "alreadyResolved": "Тази заявка вече е обработена.",
      "submittedAgo": "Подадена {{time}}",
      "statusApproved": "Одобрена",
      "statusRejected": "Отхвърлена",
      "appointment": "Час",
      "internalRejectNotePlaceholder": "Причина за отказа (по избор)"
    },
    "details": {
      "title": "Детайли за срещата",
      "unconfirmedAction": "Непотвърдена – Необходимо действие",
      "notes": "Бележки",
      "client": "Клиент:",
      "anonymous": "Анонимен",
      "resourceLabel": "Ресурс:",
      "durationMinutes": "{{count}} мин",
      "dateTime": "Дата и час:",
      "ends": "Край: {{time}}",
      "confirm": "Потвърди",
      "reschedule": "Пренасрочи",
      "aiReschedule": "AI Пренасрочване",
      "cancel": "Отмени",
      "cancelLeadTimeDisabled": "Анулирането изисква поне {{days}} дни предварително преди началото на срещата.",
      "delete": "Изтрий",
      "markNoShow": "Маркирай неявяване",
      "service": {
        "bookingType": "Резервация на услуга",
        "loading": "Зареждане на услуга…",
        "confirmationDirect": "Директна резервация",
        "confirmationNeedsApproval": "Изисква одобрение",
        "assignedResources": "Назначени ресурси",
        "primary": "Основен"
      },
      "labels": {
        "client": "Клиент",
        "resource": "Ресурс",
        "dateTime": "Дата и час",
        "format": "Формат"
      },
      "meeting": {
        "title": "Среща",
        "video": "Видео",
        "inPerson": "На място",
        "moderatorLink": "Линк за модератор",
        "memberLink": "Линк за гост",
        "joinAsModerator": "Влез като модератор",
        "join": "Влез в срещата",
        "copy": "Копирай линка",
        "copied": "{{link}} е копиран",
        "copyFailed": "Линкът не можа да бъде копиран"
      },
      "notesSection": {
        "empty": "Все още няма бележки.",
        "add": "Добави бележка",
        "edit": "Редактирай бележката",
        "modalTitle": "Бележка към срещата",
        "modalSubtitle": "Вътрешна бележка за {{client}} · {{date}}",
        "placeholder": "Детайли, които екипът трябва да знае за тази среща…",
        "save": "Запази бележката",
        "saved": "Бележката е запазена",
        "saveError": "Бележката не можа да бъде запазена"
      },
      "close": "Затвори",
      "duration": "{{count}} мин"
    },
    "manualReschedule": {
      "title": "Ръчно пренасрочване",
      "appointmentId": "Среща {{id}}",
      "client": "Клиент",
      "currentTime": "Текущо време",
      "duration": "Продължителност",
      "durationMinutes": "{{minutes}} мин.",
      "durationLocked": "{{minutes}} мин. (продължителност на услугата)",
      "service": "Услуга",
      "primaryResource": "Основен ресурс",
      "assignedResources": "Назначени ресурси",
      "alertTitle": "Пренасрочване на среща",
      "alertDescription": "Изберете нова дата и час. Клиентът ще бъде уведомен за промяната.",
      "alertDescriptionService": "Изберете нов час за тази услуга. Продължителността е фиксирана от услугата; ресурсите могат да бъдат преназначени за новото време.",
      "newStartLabel": "Нова начална дата и час",
      "placeholder": "Изберете дата и час",
      "endTime": "Краен час",
      "reschedule": "Пренасрочи",
      "rescheduling": "Пренасрочване…",
      "success": "Срещата е пренасрочена успешно",
      "error": "Неуспешно пренасрочване на среща. Моля, опитайте отново.",
      "stillChecking": "Все още се проверява наличността. Моля, изчакайте.",
      "selectValidTime": "Моля, изберете валидна дата и час.",
      "slotNotAvailable": "Избраното време не е налично. Моля, изберете друг час.",
      "newTime": "Нов час"
    },
    "resourceLink": {
      "loading": "Зареждане...",
      "unnamedResource": "Неименуван ресурс"
    },
    "create": {
      "title": "Добавяне на среща",
      "success": "Срещата е създадена успешно",
      "error": "Неуспешно създаване на среща. Моля, опитайте отново.",
      "timeslotBooked": "Този времеви интервал е вече зает. Моля, изберете друго време.",
      "timeNotAvailable": "Избраното време не е налично.",
      "exceptionPeriod": "Не може да се резервира по време на изключение: {{reason}}",
      "resourceUnavailable": "Ресурсът не е наличен",
      "validationFailed": "Неуспешна валидация",
      "resource": {
        "label": "Ресурс",
        "required": "Моля, изберете ресурс",
        "placeholder": "Изберете ресурс",
        "allServiceLinkedTitle": "Няма ресурси за директно записване",
        "allServiceLinkedDescription": "Всички ресурси са свързани с активни услуги. Превключете на „Записване на услуга“, за да ги планирате."
      },
      "duration": {
        "label": "Продължителност",
        "tooltipWithPolicy": "Продължителност на срещата в минути. Политиката изисква {{minutes}} минути.",
        "tooltip": "Продължителност на срещата в минути",
        "required": "Моля, въведете продължителност",
        "mustBeNumber": "Продължителността трябва да е число",
        "minDuration": "Продължителността трябва да е поне 5 минути",
        "maxDuration": "Продължителността не може да надвишава 8 часа",
        "policyDuration": "Продължителността трябва да е {{minutes}} минути според политиката на ресурса",
        "policyDurationMultiple": "Продължителността трябва да е кратна на {{minutes}} минути (напр. {{minutes}}, 60, 90)",
        "minutes": "минути"
      },
      "dateTime": {
        "label": "Начална дата и час",
        "tooltipWithPolicy": "Мин. предварителна заявка: {{minLead}} дни, Макс. предварителна заявка: {{maxLead}} дни. Подравняване: {{alignment}} мин. интервали.",
        "required": "Моля, изберете начална дата и час",
        "pastError": "Началният час не може да е в миналото",
        "minLeadError": "Срещите трябва да се резервират поне {{days}} дни предварително",
        "maxLeadError": "Срещите не могат да се резервират повече от {{days}} дни предварително",
        "alignmentError": "Началният час трябва да е подравнен на {{alignment}}-минутни интервали (напр. :00, :{{example1}}, :{{example2}} и т.н.)",
        "maxFutureError": "Началният час не може да е повече от 1 година в бъдещето",
        "policyNotYetEffective": "Политиката още не е в сила за избраното време",
        "policyExpired": "Политиката е изтекла за избраното време",
        "placeholder": "Изберете дата и час",
        "selectDay": "Изберете дата, за да видите наличните часове",
        "noSlotsOnDay": "Няма налични часове за този ден",
        "availableTimes": "Налични часове",
        "timezoneHint": "Часовете са в {{timezone}}",
        "calendarLegend": "Сивите дати нямат свободни часове. Точките отбелязват дни с налични слотове.",
        "loadingSlots": "Зареждане на наличност…"
      },
      "timePreview": {
        "placeholder": "Изберете дата и час по-горе, за да видите преглед"
      },
      "appointmentType": {
        "label": "Гост на срещата",
        "required": "Моля, изберете гост на срещата",
        "registeredUser": "Регистриран потребител",
        "anonymousGuest": "Анонимен/Гост"
      },
      "customer": {
        "label": "Клиент",
        "required": "Моля, изберете клиент",
        "placeholder": "Изберете регистриран клиент",
        "empty": "Няма портални клиенти за този наемател"
      },
      "guest": {
        "name": "Име на госта",
        "nameRequired": "Моля, въведете името на госта",
        "namePlaceholder": "Въведете име на госта",
        "phone": "Телефон на госта",
        "phoneRequired": "Моля, въведете телефона на госта",
        "phonePlaceholder": "Въведете телефонен номер",
        "phoneNumbersOnly": "Телефонът трябва да съдържа само цифри (и по избор + в началото)",
        "phoneInvalid": "Моля, въведете пълен и валиден телефонен номер",
        "email": "Имейл на госта",
        "emailPlaceholder": "Въведете имейл адрес",
        "emailRequired": "Моля, въведете имейла на госта",
        "emailInvalid": "Моля, въведете валиден имейл адрес"
      },
      "notes": {
        "label": "Бележки",
        "help": "Допълнителна незадължителна информация за тази среща",
        "placeholder": "Добавете допълнителни бележки или детайли за тази среща...",
        "required": "Моля, въведете бележки"
      },
      "bookingMode": {
        "label": "Тип резервация",
        "resource": "Резервирай ресурс",
        "service": "Резервирай услуга",
        "resourceHint": "Планирай време на конкретен ресурс с избрана продължителност.",
        "serviceHint": "Резервирай конфигурирана услуга; продължителността и ресурсите следват настройките на услугата."
      },
      "service": {
        "label": "Услуга",
        "required": "Моля, изберете услуга",
        "placeholder": "Изберете услуга",
        "durationTag": "{{count}} мин",
        "confirmationDirect": "Директна",
        "confirmationNeedsApproval": "Одобрение",
        "description": "Описание",
        "durationLocked": "{{count}} минути (фиксирани от услугата)",
        "padding": "Буферно време",
        "paddingValue": "{{before}} мин преди, {{after}} мин след",
        "selectionMode": "Назначаване на ресурси",
        "selectionAutoAssign": "Автоматично назначаване",
        "selectionClientPrimary": "Клиентът избира основен ресурс",
        "bookingStatus": "След резервацията",
        "statusConfirmed": "Създава се като Потвърдена",
        "statusScheduled": "Създава се като Планирана (изисква одобрение)",
        "noServicesTitle": "Няма активни услуги",
        "noServicesDescription": "Създайте и активирайте услуга преди резервация.",
        "noServicesLink": "Управление на услуги"
      },
      "primaryResource": {
        "label": "Основен ресурс",
        "required": "Моля, изберете основен ресурс",
        "placeholder": "Изберете основен ресурс",
        "noCandidates": "Няма активни ресурси, свързани с основната роля за тази услуга."
      },
      "reminder": {
        "label": "Създай напомняне",
        "prefillTitle": "Напомняне за последващо действие по среща"
      },
      "actions": {
        "cancel": "Отказ",
        "creating": "Създаване...",
        "checkingAvailability": "Проверка на наличността...",
        "createAppointment": "Създай среща",
        "createConfirmed": "Създай като потвърдена"
      },
      "conflicts": {
        "timeslotBooked": "Времевият интервал е зает",
        "timeslotConflict": "Този времеви интервал се припокрива с вече съществуваща среща:",
        "time": "Час:",
        "status": "Статус:",
        "selectDifferentTimeOrResource": "Моля, изберете различно време или ресурс.",
        "outsideHours": "Извън работните часове",
        "availableHours": "Работни часове:",
        "selectWithinHours": "Моля, изберете час в рамките на работните часове на ресурса.",
        "resourceUnavailable": "Ресурсът не е наличен",
        "exceptionPeriod": "Избраното време попада в период на изключение:",
        "period": "Период:",
        "reason": "Причина:",
        "selectDifferentTime": "Моля, изберете различно време.",
        "checkingAvailability": "Проверка на наличността..."
      },
      "sections": {
        "booking": "Резервация",
        "dateTime": "Дата и час",
        "guest": "Гост",
        "details": "Подробности"
      },
      "format": {
        "label": "Формат на срещата",
        "required": "Моля, изберете формат на срещата",
        "inPerson": "На място",
        "video": "Видео разговор"
      }
    },
    "weekdays": {
      "monday": "Понеделник",
      "tuesday": "Вторник",
      "wednesday": "Сряда",
      "thursday": "Четвъртък",
      "friday": "Петък",
      "saturday": "Събота",
      "sunday": "Неделя"
    },
    "availabilityValidation": {
      "closedDay": "{{weekday}} е маркиран като затворен за този ресурс.",
      "closedLabel": "Затворено",
      "outsideHours": "Избраното време е извън работните часове за {{weekday}}.",
      "notAvailable": "Не е налично"
    }
  },
  "customers": {
    "title": "Клиенти",
    "description": "Портални клиенти, регистрирани за този наемател. Появяват се след покана и регистрация.",
    "search": "Търсене на клиенти",
    "empty": "Все още няма портални клиенти. Те се появяват след като приемат покана и се регистрират.",
    "filters": {
      "refresh": "Обнови",
      "customersCount": "{{filtered}} от {{total}}"
    },
    "table": {
      "title": "Клиенти",
      "loading": "Зареждане на клиенти…",
      "showingRange": "{{start}}–{{end}} от {{total}}",
      "noMatchFilters": "Няма клиенти, съответстващи на търсенето",
      "noCustomersHint": "Поканете клиент от CRM; те се появяват тук след регистрация.",
      "clearFilters": "Изчисти търсенето"
    },
    "columns": {
      "name": "Име",
      "email": "Имейл",
      "phone": "Телефон",
      "membership": "Членство",
      "verified": "Потвърден",
      "created": "Създаден",
      "actions": "Действия",
      "verifiedEmail": "Имейл",
      "verifiedPhone": "Телефон"
    },
    "remove": {
      "confirmTitle": "Премахване на клиента?",
      "confirmDesc": "Клиентът губи достъп до този тенант.",
      "ok": "Премахни",
      "cancel": "Отказ",
      "button": "Премахни"
    }
  },
  "employees": {
    "title": "Служители",
    "description": "Управлявайте членове на екипа, роли и статуси.",
    "companiesAndEmployees": "Компании / Служители",
    "companiesAndEmployeesDescription": "Управлявайте компаниите и членовете на екипа си.",
    "companyCreateSuccess": "Компанията е създадена",
    "companyUpdateSuccess": "Компанията е актуализирана",
    "companyDeleteSuccess": "Компанията е изтрита",
    "companyDeleteError": "Неуспешно изтриване на компанията",
    "roles": {
      "admin": "Администратор",
      "manager": "Мениджър",
      "agent": "Агент",
      "viewer": "Наблюдател",
      "owner": "Собственик",
      "employee": "Служител"
    },
    "statusLabels": {
      "active": "АКТИВЕН",
      "inactive": "НЕАКТИВЕН"
    },
    "stats": {
      "active": "активни",
      "totalMembers": "общо членове"
    },
    "table": {
      "name": "Име",
      "email": "Имейл",
      "phone": "Телефон",
      "role": "Роля",
      "tenantRole": "Роля в наемателя",
      "status": "Статус",
      "actions": "Действия",
      "joined": "Присъединен",
      "loading": "Зареждане на служители...",
      "showingRange": "Показване на {{start}}-{{end}} от {{total}} служители",
      "filteredFrom": "(филтрирано от {{total}} общо)",
      "noMatchFilters": "Няма служители, отговарящи на филтрите",
      "noEmployees": "Все още няма служители",
      "clearFilters": "Изчисти филтрите",
      "copyEmail": "Копирай",
      "copied": "Копирано!"
    },
    "filters": {
      "searchPlaceholder": "Търсене по име, имейл или телефон",
      "rolePlaceholder": "Роля",
      "statusPlaceholder": "Статус",
      "active": "Активен",
      "inactive": "Неактивен",
      "clearAll": "Изчисти филтрите"
    },
    "actions": {
      "newEmployee": "Нов служител",
      "inviteEmployee": "Поканване на служител"
    },
    "modal": {
      "editTitle": "Редактиране на служител",
      "createTitle": "Нов служител",
      "saveButton": "Запази",
      "createButton": "Създай"
    },
    "form": {
      "fullName": "Пълно име",
      "fullNameRequired": "Моля, въведете пълно име",
      "fullNamePlaceholder": "напр. Иван Иванов",
      "email": "Имейл",
      "emailRequired": "Моля, въведете валиден имейл",
      "emailPlaceholder": "name@example.com",
      "phone": "Телефон",
      "phonePlaceholder": "По избор",
      "role": "Роля",
      "status": "Статус"
    },
    "messages": {
      "removeSuccess": "Служителят е премахнат",
      "removeError": "Неуспешно премахване",
      "updateSuccess": "Служителят е актуализиран",
      "createSuccess": "Служителят е създаден",
      "saveError": "Неуспешно запазване"
    },
    "selectClientHint": "Моля, изберете клиент от падащото меню по-горе",
    "noTenantHint": "Не е избран наемател",
    "invite": {
      "contextTitle": "Поканете член на екипа",
      "contextTitleCompany": "Покана за {{company}}",
      "title": "Поканване на служител",
      "description": "Генерирайте връзка за покана, за да добавите нов член на екипа. Споделете връзката с човека, който искате да поканите.",
      "roleLabel": "Роля",
      "generateLink": "Генерирай връзка за покана",
      "cancel": "Отказ",
      "close": "Затвори",
      "successTitle": "Връзката за покана е генерирана",
      "successDescription": "Споделете тази връзка с човека, който искате да поканите. Връзката изтича след 5 дни.",
      "linkDetails": "Връзка за покана",
      "copyLink": "Копирай връзка за регистрация",
      "copySuccess": "Връзката е копирана в клипборда",
      "tokenSuccess": "Връзката за покана е генерирана",
      "tokenError": "Неуспешно генериране на връзка за покана"
    },
    "tenantRoleEditor": {
      "editTooltip": "Промяна на ролята на наемателя",
      "changeTitle": "Промяна на ролята на наемателя",
      "selectRole": "Моля, изберете роля",
      "noChanges": "Няма промени за запазване",
      "updateSuccess": "Ролята е актуализирана успешно",
      "updateError": "Неуспешна актуализация на ролята",
      "editingFor": "Редактиране на роля за",
      "selectNewRole": "Изберете нова роля",
      "saveChanges": "Запази промените",
      "cancel": "Отказ",
      "current": "Текуща",
      "confirmTitle": "Потвърдете промяната на ролята",
      "confirmDescription": "Да се промени ролята на {{role}}?"
    }
  },
  "companySettings": {
    "title": "Настройки на компанията",
    "description": "Конфигурирайте поведението, инструментите, паметта и сигурността на вашия AI агент.",
    "pageDescription": "Конфигурирайте предпочитанията на наемателя за вашата компания.",
    "actions": {
      "resetDefaults": "Възстановяване на настройки по подразбиране",
      "save": "Запази"
    },
    "weeklySummary": {
      "sectionTitle": "Седмично резюме на Smart Assistant",
      "sectionDescription": "Всеки понеделник избраният получател получава кратко резюме за предишния понеделник–неделя. Седмици без взаимодействия не се изпращат по имейл.",
      "sendLabel": "Изпращане на седмично резюме",
      "sendHelp": "Връзката за отписване в имейла управлява същия превключвател.",
      "recipientLabel": "Получател",
      "recipientHelp": "Изберете активен член на този наемател.",
      "recipientPlaceholder": "Изберете получател",
      "recipientRequired": "Изберете получател, преди да включите седмичното резюме.",
      "languageLabel": "Бизнес език",
      "on": "Вкл.",
      "off": "Изкл.",
      "languages": {
        "en": "English",
        "bg": "Български",
        "de": "Deutsch"
      },
      "selectTenant": "Изберете наемател, за да конфигурирате настройките на компанията.",
      "saveSuccess": "Настройката за седмичното имейл резюме е запазена.",
      "saveError": "Настройката за седмичното резюме не можа да бъде запазена."
    },
    "model": {
      "sectionTitle": "Модел",
      "sectionDescription": "Тези опции контролират как вашият AI комуникира. Ако не сте сигурни, запазете настройките по подразбиране — те са безопасни и подходящи за повечето екипи.",
      "provider": "Доставчик",
      "providerHelp": "Кой захранва AI. Различните доставчици предлагат различни модели и цени.",
      "modelName": "Модел",
      "modelNameHelp": "Конкретният AI мозък. По-новите модели обикновено разсъждават по-добре, но могат да струват повече.",
      "modelNamePlaceholder": "напр. gpt-4o, claude-3.5-sonnet",
      "streaming": "Поточно предаване",
      "streamingHelp": "Показва отговора на AI, докато се пише. Чувства се по-бързо за потребителите.",
      "temperature": "Температура",
      "temperatureHelp": "Колко креативен трябва да бъде AI. Ниско = фактическо и последователно. Високо = изобретателно и разнообразно.",
      "maxTokens": "Макс. токени",
      "maxTokensHelp": "Мек лимит за дължината на отговора. По-високи стойности позволяват по-дълги, по-детайлни отговори.",
      "systemPrompt": "Системен промпт",
      "systemPromptHelp": "Кратка роля или личност за вашия AI. Например: 'Бъди кратък и приятелски. Задавай допълнителни въпроси, ако е необходимо.'",
      "systemPromptPlaceholder": "Как трябва да се държи AI? Бъдете прости."
    },
    "knowledge": {
      "sectionTitle": "Знание",
      "sectionDescription": "Решете дали AI трябва да запомня разговора и да търси отговори в базата ви със знания.",
      "enableMemory": "Запомняне на разговора",
      "enableMemoryHelp": "Запазва скорошния контекст на чата, за да може AI да се връща към казаното.",
      "enableRag": "Използване на фирмено знание",
      "enableRagHelp": "Позволява на AI да търси във вашите документи/база знания за точни отговори.",
      "ragTopK": "Брой резултати",
      "ragTopKHelp": "Колко съвпадащи документа да се вземат предвид. Започнете с 5 — увеличете, ако отговорите пропускат детайли."
    },
    "messages": {
      "defaultsRestored": "Настройките по подразбиране са възстановени",
      "settingsSaved": "Настройките са запазени",
      "validationError": "Поправете грешките за валидиране преди запазване"
    }
  },
  "knowledge": {
    "title": "База знания",
    "description": "Уебсайтове, документи и въпроси и отговори, с които вашите AI агенти отговарят на въпроси.",
    "selectTenant": "Изберете клиент, за да управлявате неговата база знания.",
    "stats": {
      "documents": "Документи",
      "chunks": "Индексирани откъси",
      "websites": "Уебсайтове",
      "activeJobs": "В обработка",
      "lastSync": "Последна синхронизация",
      "never": "Никога",
      "failed": "{{count}} неуспешни",
      "documentsHint": "От уебсайтове, файлове и ЧЗВ",
      "chunksHint": "Достъпни за вашите AI агенти",
      "pagesHint": "{{count}} обходени страници",
      "processingHint": "Тече индексиране…",
      "upToDate": "Всичко е актуално"
    },
    "tabs": {
      "company": "Фирма",
      "websites": "Уебсайтове",
      "documents": "Документи",
      "text": "Текст и ЧЗВ",
      "search": "Тестово търсене",
      "activity": "Активност"
    },
    "status": {
      "source": {
        "IDLE": "Неактивен",
        "SYNCING": "Синхронизира се",
        "READY": "Готов",
        "ERROR": "Грешка"
      },
      "document": {
        "PENDING": "В опашка",
        "PROCESSING": "Обработва се",
        "INDEXED": "Индексиран",
        "SKIPPED": "Пропуснат",
        "FAILED": "Неуспешен"
      },
      "job": {
        "QUEUED": "В опашка",
        "RUNNING": "Изпълнява се",
        "SUCCEEDED": "Успешен",
        "FAILED": "Неуспешен",
        "CANCELLED": "Отменен"
      }
    },
    "kinds": {
      "WEB_PAGE": "Уеб страница",
      "FILE": "Файл",
      "TEXT": "Бележка",
      "FAQ": "ЧЗВ"
    },
    "types": {
      "WEBSITE": "Уебсайтове",
      "DOCUMENT": "Документи",
      "TEXT": "Текст и ЧЗВ"
    },
    "jobTypes": {
      "SYNC_SOURCE": "Синхронизация на сайт",
      "INDEX_DOCUMENT": "Индексиране"
    },
    "triggers": {
      "CREATE": "Създаване",
      "MANUAL": "Ръчно",
      "SCHEDULED": "По график",
      "UPLOAD": "Качване",
      "EDIT": "Редакция"
    },
    "common": {
      "actions": "Действия",
      "edit": "Редактирай",
      "delete": "Изтрий",
      "reindex": "Индексирай отново",
      "download": "Изтегли",
      "view": "Детайли",
      "refresh": "Опресни",
      "cancel": "Отказ",
      "save": "Запази",
      "create": "Създай",
      "status": "Статус",
      "title": "Заглавие",
      "updated": "Обновен",
      "chunks": "Откъси",
      "searchPlaceholder": "Търсене по заглавие или URL",
      "allStatuses": "Всички статуси",
      "error": "Нещо се обърка. Моля, опитайте отново.",
      "reindexQueued": "Повторното индексиране е насрочено",
      "deleted": "Изтрито",
      "saved": "Запазено",
      "all": "Всички",
      "noMatches": "Няма резултати за избраните филтри.",
      "showMore": "Покажи още",
      "showLess": "Покажи по-малко"
    },
    "websites": {
      "add": "Добави уебсайт",
      "empty": "Агентът ще научи всичко от страниците ви – услуги, цени, контакти – и ще ги поддържа актуални автоматично.",
      "columns": {
        "name": "Уебсайт",
        "pages": "Страници",
        "lastSync": "Последна синхронизация",
        "schedule": "График",
        "enabled": "Активен",
        "content": "Съдържание"
      },
      "sync": "Синхронизирай",
      "syncQueued": "Синхронизацията е насрочена",
      "syncAlreadyRunning": "За този сайт вече тече синхронизация",
      "deleteConfirm": "Изтриване на уебсайта?",
      "deleteDescription": "Всички обходени страници ще бъдат премахнати от базата знания.",
      "created": "Уебсайтът е добавен. Първото обхождане започна.",
      "lastError": "Последна грешка",
      "failedPages": "{{count}} неуспешни страници",
      "pagesCount": "{{count}} страници",
      "passagesCount": "{{count}} откъса",
      "nextSync": "Следваща синхронизация {{time}}",
      "intro": "Страниците се обхождат автоматично и се поддържат актуални по избрания график.",
      "emptyTitle": "Добавете сайта на фирмата"
    },
    "websiteForm": {
      "createTitle": "Добавяне на уебсайт",
      "editTitle": "Редактирай уебсайт",
      "startUrl": "Начален URL",
      "startUrlHelp": "Обхождането следва връзки в същия домейн, започвайки от тази страница.",
      "startUrlInvalid": "Въведете валиден http(s) адрес",
      "name": "Име",
      "namePlaceholder": "По подразбиране – домейнът",
      "schedule": "Автоматична синхронизация",
      "advanced": "Настройки на обхождането",
      "maxDepth": "Дълбочина на връзките",
      "maxDepthHelp": "Колко клика от началната страница да се следват (0 = само началната страница).",
      "maxPages": "Макс. страници",
      "include": "Само тези пътища",
      "includeHelp": "Обхождат се само пътища, отговарящи на тези шаблони, напр. /products/*. Оставете празно, за да се обходи всичко.",
      "exclude": "Изключи пътища",
      "excludeHelp": "Пътища, отговарящи на тези шаблони, никога не се обхождат, напр. /blog/*.",
      "respectRobots": "Спазвай robots.txt",
      "useSitemap": "Използвай sitemap.xml",
      "resyncNote": "Промяната на настройките стартира нова синхронизация.",
      "respectRobotsHelp": "Пропуска страниците, които собственикът на сайта е забранил за обхождане, например количка или профил. Препоръчително е да остане включено.",
      "useSitemapHelp": "Чете и списъка с всички страници на сайта, така че се намират и страници, към които няма връзка в менюто. Тези страници се броят към „Макс. страници“.",
      "maxPagesHelp": "Обхождането спира след толкова страници (най-много 500).",
      "summary": "Дълбочина {{depth}} · до {{pages}} страници",
      "createButton": "Създай уебсайт"
    },
    "schedule": {
      "manual": "Само ръчно",
      "daily": "Ежедневно",
      "weekly": "Седмично",
      "monthly": "Месечно",
      "everyHours": "На всеки {{count}} ч."
    },
    "documents": {
      "uploadTitle": "Кликнете или плъзнете файлове тук",
      "uploadHint": "PDF, DOCX, TXT, MD или CSV · до {{size}} MB на файл",
      "uploaded": "{{count}} файл(а) са качени и чакат индексиране",
      "rejected": "{{name}} беше отхвърлен: {{reason}}",
      "tooLarge": "{{name}} е {{actual}}; файловете може да са най-много {{size}} MB",
      "unsupported": "{{name}} не може да бъде качен: поддържат се само файлове {{types}}",
      "empty": "Все още няма качени документи.",
      "columns": {
        "file": "Файл",
        "size": "Размер"
      },
      "deleteConfirm": "Изтриване на документа?",
      "reindexAll": "Индексирай всички",
      "reindexAllConfirm": "Да се обработят ли отново всички документи с най-новото извличане?",
      "reindexAllQueued": "{{count}} документа са насрочени за повторно индексиране"
    },
    "text": {
      "addFaq": "Добави ЧЗВ",
      "addNote": "Добави бележка",
      "empty": "Добавете ЧЗВ и бележки за неща, които ги няма на сайта – правила, детайли за цени, вътрешни знания.",
      "faqTitle": "Добавяне на ЧЗВ",
      "noteTitle": "Добавяне на бележка",
      "editFaq": "Редактирай ЧЗВ",
      "editNote": "Редактирай бележка",
      "question": "Въпрос",
      "answer": "Отговор",
      "title": "Заглавие",
      "content": "Съдържание",
      "titleOptional": "Заглавие (незадължително)",
      "required": "Полето е задължително",
      "deleteConfirm": "Изтриване на записа?",
      "entry": "Запис",
      "emptyTitle": "Отговорете директно на честите въпроси",
      "searchPlaceholder": "Търсене във въпроси и бележки",
      "createFaq": "Създай ЧЗВ",
      "createNote": "Създай бележка"
    },
    "detail": {
      "pages": "Страници",
      "jobs": "История на синхронизациите",
      "content": "Извлечен текст",
      "chunks": "Индексирани откъси",
      "noChunks": "Все още няма индексирано съдържание.",
      "info": "Детайли",
      "url": "URL",
      "depth": "Дълбочина",
      "httpStatus": "HTTP статус",
      "error": "Грешка",
      "indexedAt": "Индексиран",
      "size": "Размер",
      "kind": "Тип",
      "page": "Страница {{page}}",
      "tokens": "~{{count}} токена",
      "truncated": "Показани са първите {{count}} символа.",
      "pageColumn": "Страница",
      "siteWide": "Общо за сайта",
      "siteWideHint": "Съдържание, повтарящо се на няколко страници (контакти, тийзъри, футъри). Индексира се веднъж тук, а не на всяка страница."
    },
    "search": {
      "description": "Задайте въпрос като клиент. Това са откъсите, които вашият AI агент получава, за да отговори.",
      "placeholder": "напр. Какво е работното ви време?",
      "run": "Търси",
      "topK": "Резултати",
      "sources": "Източници",
      "allSources": "Всички източници",
      "empty": "Пуснете търсене, за да видите резултатите.",
      "noResults": "Няма подходящи откъси. Агентът ще каже, че не знае, вместо да гадае.",
      "score": "Релевантност {{score}}",
      "took": "{{count}} резултата за {{ms}} ms",
      "examples": [
        "Какво е работното ви време?",
        "Какви услуги предлагате?",
        "Как мога да се свържа с вас?"
      ],
      "relevance": {
        "strong": "Силно съвпадение",
        "good": "Добро съвпадение",
        "weak": "Слабо съвпадение",
        "keyword": "Съвпадение по дума"
      },
      "similarityTooltip": "Смислова близост {{value}} (0–1)",
      "keywordTooltip": "Думите ви се срещат точно, но без силно смислово съвпадение"
    },
    "jobs": {
      "empty": "Все още няма активност.",
      "columns": {
        "type": "Задача",
        "target": "Източник / документ",
        "trigger": "Причина",
        "status": "Статус",
        "result": "Резултат",
        "started": "Започната",
        "duration": "Времетраене"
      },
      "summary": "{{indexed}} индексирани · {{unchanged}} без промяна · {{skipped}} пропуснати · {{failed}} неуспешни · {{removed}} премахнати",
      "attempt": "Опит {{attempts}}/{{max}}",
      "retryAt": "Нов опит {{time}}"
    },
    "company": {
      "title": "Информация за фирмата",
      "description": "Име, адрес, данни за контакт и работно време, с които отговаря вашият AI агент (инструмент getCompanyInformation). Взимат се от структурираните данни и страницата за контакт на сайта ви при всяка синхронизация; вашите корекции са с предимство.",
      "edit": "Редактиране",
      "editTitle": "Редактиране на информацията за фирмата",
      "editHelp": "Промените заместват стойностите от сайта ви и се запазват при следващи синхронизации. Полетата, които съвпадат със сайта, продължават да се обновяват автоматично.",
      "resetToWebsite": "Използвай стойността от сайта",
      "clear": "Изчисти",
      "openingHoursHelp": "Въведете запис и натиснете Enter, напр. „Пн-Пт 08:00-18:00“ или „Сб затворено“.",
      "emptyNoWebsite": "Все още няма информация за фирмата. Добавете сайта си и тя ще бъде извлечена автоматично.",
      "emptyNoData": "На сайта ви все още не е открита информация за фирмата. Добавете я ръчно чрез „Редактиране“.",
      "addWebsite": "Добави уебсайт",
      "extractedFrom": "Извлечено от {{sources}}",
      "origin": {
        "jsonld": "Данни от сайта",
        "website": "Страница за контакт",
        "override": "Редактирано"
      },
      "fields": {
        "name": "Име",
        "legalName": "Юридическо име",
        "address": "Адрес",
        "phones": "Телефон",
        "emails": "Имейл",
        "fax": "Факс",
        "openingHours": "Работно време",
        "website": "Уебсайт",
        "socialLinks": "Социални мрежи",
        "areaServed": "Обслужван район",
        "priceRange": "Ценови диапазон",
        "description": "Описание"
      },
      "address": {
        "street": "Улица и номер",
        "postalCode": "Пощенски код",
        "city": "Град",
        "region": "Област",
        "country": "Държава"
      },
      "placeholders": {
        "phones": "Добави телефон",
        "emails": "Добави имейл",
        "openingHours": "Добави работно време",
        "socialLinks": "Добави линк към профил"
      }
    }
  },
  "permissions": {
    "title": "Управление на права за достъп",
    "connectProfiles": {
      "title": "Свързване на профили",
      "description": "Свържете профила си с други услуги, за да улесните процеса на влизане.",
      "connectGoogle": "Свързване с Google",
      "googleSuccess": "Google акаунтът е свързан успешно!",
      "googleError": "Неуспешно свързване на Google акаунт"
    },
    "userPermissions": {
      "title": "Потребителски права",
      "description": "Управлявайте роли и права за достъп за вашата организация."
    }
  },
  "shop": {
    "title": "Магазин",
    "description": "Управлявайте вашия онлайн магазин с AI помощ за доставка, ценообразуване и съдържание.",
    "stats": {
      "orders": "Поръчки",
      "pending": "Изчакващи",
      "paid": "Платени",
      "revenue": "Приходи"
    },
    "orders": {
      "title": "Поръчки",
      "searchPlaceholder": "Търсене на поръчки...",
      "filterPending": "Изчакващи",
      "filterPaid": "Платени",
      "filterFulfilled": "Изпълнени",
      "filterCancelled": "Отменени",
      "filterAll": "Всички",
      "table": {
        "order": "Поръчка",
        "customer": "Клиент",
        "total": "Общо",
        "status": "Статус",
        "actions": "Действия",
        "items": "{{count}} артикула"
      },
      "actions": {
        "fulfill": "Изпълни",
        "cancel": "Отмени"
      },
      "messages": {
        "fulfilling": "AI подготвя стъпки за доставка...",
        "fulfillSuccess": "Поръчката е изпълнена. Етикет за доставка и имейл са подготвени от AI.",
        "cancelTitle": "Отмяна на поръчка",
        "cancelContent": "Клиентът ще бъде уведомен и артикулите ще бъдат върнати в наличност.",
        "cancelButton": "Отмени поръчка",
        "cancelling": "AI съставя имейл за отмяна...",
        "cancelSuccess": "Поръчката е отменена и имейлът е изпратен."
      }
    },
    "products": {
      "title": "Продукти",
      "newProduct": "Нов продукт",
      "table": {
        "product": "Продукт",
        "sku": "Арт. №",
        "price": "Цена",
        "stock": "Наличност",
        "category": "Категория",
        "status": "Статус",
        "actions": "Действия"
      },
      "statusActive": "АКТИВЕН",
      "statusInactive": "НЕАКТИВЕН",
      "actions": {
        "aiPrice": "AI цена",
        "aiDescription": "AI описание",
        "edit": "Редактирай"
      },
      "drawer": {
        "editTitle": "Редактиране на продукт",
        "createTitle": "Нов продукт",
        "cancel": "Отказ",
        "save": "Запази"
      },
      "form": {
        "name": "Име",
        "nameRequired": "Въведете име на продукт",
        "namePlaceholder": "напр. Премиум суитшърт",
        "sku": "Арт. №",
        "skuPlaceholder": "По избор",
        "category": "Категория",
        "categoryPlaceholder": "напр. Стоки",
        "price": "Цена",
        "stock": "Наличност"
      },
      "messages": {
        "updateSuccess": "Продуктът е актуализиран",
        "createSuccess": "Продуктът е създаден",
        "aiAnalyzing": "AI анализира подобни продукти и търсене...",
        "aiSuggestedPrice": "Предложена цена: ${{price}}"
      },
      "aiDescription": {
        "title": "AI описание на продукт",
        "body": "Внимателно изработен артикул, който клиентите ви ще обичат. Ясна стойност, модерен дизайн и надеждно качество.",
        "highlights": "Предимства: бърза доставка, лесно връщане и отлична поддръжка."
      }
    }
  },
  "tasksProjects": {
    "title": "Задачи и проекти",
    "description": "Планирайте и проследявайте работата на вашия AI агент и екип.",
    "stats": {
      "myOpenTasks": "Моите отворени задачи",
      "teamOpenTasks": "Отворени задачи на екипа",
      "projectsInProgress": "Проекти в процес"
    },
    "tabs": {
      "overview": "Преглед",
      "projects": "Проекти",
      "notifications": "Известия"
    },
    "tasks": {
      "myTasks": "Моите задачи",
      "teamTasks": "Задачи на екипа",
      "addPersonalPlaceholder": "Добави лична задача",
      "addTeamPlaceholder": "Добави задача на екипа",
      "addButton": "Добави",
      "noTasks": "Няма задачи",
      "statusNotStarted": "Незапочната",
      "statusInProgress": "В процес",
      "statusDone": "Готова",
      "priorityLow": "Нисък",
      "priorityMedium": "Среден",
      "priorityHigh": "Висок",
      "due": "Краен срок {{date}}"
    },
    "projects": {
      "backlog": "Чакащи",
      "inProgress": "В процес",
      "done": "Готови"
    },
    "notifications": {
      "title": "Предстоящи и скорошни"
    }
  },
  "videoMeetings": {
    "title": "Видео срещи",
    "description": "Преглед и управление на видео срещи с вашите клиенти.",
    "stats": {
      "totalMeetings": "Общо срещи",
      "scheduled": "Планирани",
      "confirmed": "Потвърдени",
      "today": "Днес"
    },
    "filters": {
      "searchPlaceholder": "Търсене на срещи...",
      "statusPlaceholder": "Филтър по статус",
      "scheduled": "Планирана",
      "confirmed": "Потвърдена",
      "completed": "Завършена",
      "cancelled": "Отменена",
      "noShow": "Неявяване",
      "startDate": "Начална дата",
      "endDate": "Крайна дата",
      "clear": "Изчисти"
    },
    "table": {
      "client": "Клиент",
      "meetingDetails": "Детайли за срещата",
      "dateTime": "Дата и час",
      "status": "Статус",
      "actions": "Действия",
      "minutes": "{{count}} минути",
      "anonymous": "Анонимен",
      "interviewTitle": "Интервю: {{position}}",
      "appointmentTitle": "Среща {{id}}",
      "interviewDescription": "Интервю за позиция: {{position}}",
      "title": "Видео срещи",
      "empty": "Все още няма видео срещи",
      "noMatchFilters": "Няма срещи, отговарящи на филтрите"
    },
    "actions": {
      "viewDetails": "Детайли",
      "joinMeeting": "Присъедини се",
      "copyUrl": "Копирай URL",
      "copyMeetingUrl": "Копирай URL на среща"
    },
    "messages": {
      "urlCopied": "URL на срещата е копиран в клипборда!",
      "urlCopyFailed": "Неуспешно копиране на URL в клипборда",
      "noMeetingUrl": "Няма наличен URL за среща за тази среща"
    },
    "pagination": "{{start}}-{{end}} от {{total}} срещи"
  },
  "clients": {
    "title": "Клиентски лийдове",
    "description": "Управление на лийдове.",
    "addNewLead": "Добави нов лийд",
    "stats": {
      "totalLeads": "Общо лийдове",
      "registered": "Регистрирани",
      "active": "Активни",
      "converted": "Конвертирани"
    },
    "filters": {
      "searchPlaceholder": "Търсене по име, имейл или телефон",
      "statusPlaceholder": "Статус",
      "sourcePlaceholder": "Източник",
      "registrationPlaceholder": "Регистрация",
      "clearFilters": "Изчисти филтри",
      "export": "Експорт"
    },
    "status": {
      "active": "Активен",
      "inactive": "Неактивен",
      "converted": "Конвертиран"
    },
    "source": {
      "websiteWidget": "Уеб уиджет",
      "email": "Имейл",
      "voiceCall": "Телефонно обаждане",
      "sms": "SMS",
      "socialMedia": "Социални мрежи",
      "other": "Друго"
    },
    "registration": {
      "registered": "Регистриран",
      "unregistered": "Нерегистриран"
    },
    "table": {
      "client": "Клиент",
      "status": "Статус",
      "registration": "Регистрация",
      "source": "Източник",
      "tags": "Тагове",
      "lastInteraction": "Последна комуникация",
      "actions": "Действия"
    },
    "fallback": {
      "anonymousClient": "Анонимен клиент",
      "unknownClient": "Непознат клиент",
      "noContactInfo": "Няма данни за контакт"
    },
    "actions": {
      "viewDetails": "Виж детайли",
      "edit": "Редактирай",
      "register": "Регистрирай",
      "delete": "Изтрий",
      "viewChatHistory": "Виж история на чата",
      "viewMeetingHistory": "Виж история на срещите"
    },
    "pagination": "{{start}}-{{end}} от {{total}} лийдове",
    "modal": {
      "editTitle": "Редактиране на клиентски лийд",
      "createTitle": "Създаване на нов клиентски лийд",
      "updateButton": "Актуализирай лийд",
      "createButton": "Създай лийд"
    },
    "form": {
      "fullName": "Пълно име",
      "fullNameRequired": "Моля, въведете име",
      "fullNamePlaceholder": "Въведете име на клиент",
      "source": "Източник",
      "sourceRequired": "Моля, изберете източник",
      "sourcePlaceholder": "Изберете източник",
      "email": "Имейл адрес",
      "emailInvalid": "Моля, въведете валиден имейл",
      "emailPlaceholder": "Въведете имейл адрес",
      "phone": "Телефонен номер",
      "phonePlaceholder": "Въведете телефонен номер",
      "tags": "Тагове",
      "tagsPlaceholder": "Въведете тагове (Enter за добавяне)"
    },
    "messages": {
      "createSuccess": "Клиентският лийд е създаден успешно!",
      "createError": "Неуспешно създаване на клиентски лийд",
      "updateSuccess": "Клиентският лийд е актуализиран успешно!",
      "updateError": "Неуспешна актуализация на клиентски лийд",
      "deleteTitle": "Сигурни ли сте, че искате да изтриете този клиентски лийд?",
      "deleteContent": "Това действие не може да бъде отменено.",
      "deleteOk": "Да, изтрий",
      "deleteSuccess": "Клиентският лийд е изтрит успешно!",
      "deleteError": "Неуспешно изтриване на клиентски лийд",
      "registerSuccess": "Клиентският лийд е регистриран успешно!",
      "registerError": "Неуспешна регистрация на клиентски лийд"
    },
    "meetingHistory": {
      "title": "История на срещите",
      "modalTitle": "История на срещите - {{name}}",
      "videoMeeting": "Видео среща",
      "inPersonMeeting": "Лична среща",
      "noAgentAssigned": "Няма присвоен агент",
      "notes": "Бележки:",
      "tags": "Тагове:",
      "loading": "Зареждане на история на срещите...",
      "noHistory": "Няма намерена история на срещите за този клиент.",
      "noHistoryHint": "Срещите ще се показват тук, когато клиентът е насрочил срещи."
    }
  },
  "leads": {
    "title": "Лийдове",
    "description": "Проследявайте и управлявайте лийдове, събрани от всички канали.",
    "loadError": "Неуспешно зареждане на лийдове",
    "tryAgain": "Опитай отново",
    "stats": {
      "totalLeads": "Общо лийдове",
      "newLeads": "Нови",
      "qualifiedLeads": "Квалифицирани",
      "disqualifiedLeads": "Дисквалифицирани",
      "convertedLeads": "Конвертирани"
    },
    "filters": {
      "searchPlaceholder": "Търсене по име, имейл или телефон...",
      "statusPlaceholder": "Всички статуси",
      "channelPlaceholder": "Всички канали",
      "refresh": "Опресни",
      "clearAll": "Изчисти всички",
      "activeFilters": "Активни филтри:",
      "searchTag": "Търсене: \"{{text}}\"",
      "statusTag": "Статус: {{status}}",
      "channelTag": "Канал: {{channel}}",
      "leadsCount": "{{filtered}} / {{total}} лийдове"
    },
    "status": {
      "NEW": "Нов",
      "QUALIFIED": "Квалифициран",
      "DISQUALIFIED": "Дисквалифициран",
      "CONVERTED": "Конвертиран"
    },
    "channel": {
      "CHAT_WIDGET": "Чат уиджет",
      "EMAIL": "Имейл",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "PHONE_CALL": "Телефонно обаждане",
      "OTHER": "Друго"
    },
    "table": {
      "title": "Всички лийдове",
      "lead": "Лид",
      "channel": "Канал",
      "status": "Статус",
      "verified": "Верифициран",
      "created": "Създаден",
      "lastUpdated": "Последна актуализация",
      "actions": "Действия",
      "viewDetails": "Виж детайли",
      "view": "Преглед",
      "loading": "Зареждане на лийдове...",
      "leadCount": "{{count}} лийд",
      "leadCount_plural": "{{count}} лийда",
      "showingRange": "Показване на {{start}}-{{end}} от {{total}} лийда",
      "noMatchFilters": "Няма лийдове, отговарящи на критериите за филтриране",
      "noLeadsFound": "Все още няма намерени лийдове",
      "noLeadsHint": "Лийдовете ще се показват тук, когато бъдат събрани чрез вашите канали.",
      "clearFilters": "Изчисти филтрите",
      "emailVerified": "Имейлът е верифициран",
      "phoneVerified": "Телефонът е верифициран",
      "notVerified": "Не е верифициран",
      "anonymous": "Анонимен лийд",
      "noContactInfo": "Няма контактни данни",
      "authenticated": "Автентикиран чрез имейл код",
      "authenticatedShort": "Авт.",
      "ip": "IP",
      "convert": "Конвертирай"
    },
    "convert": {
      "convertToCustomer": "Конвертирай в клиент",
      "confirmTitle": "Конвертиране на лийда в клиент?",
      "confirmDescription": "Ще бъде създаден клиентски профил от контактните и верификационните данни на този лийд.",
      "success": "{{name}} е промотиран до клиент",
      "error": "Неуспешно конвертиране на лийда в клиент",
      "requiresVerification": "Имейлът или телефонът трябва да са верифицирани преди конверсия",
      "alreadyConverted": "Този лийд вече е конвертиран",
      "converting": "Конвертиране..."
    }
  },
  "leadDetail": {
    "loading": "Зареждане на детайли за лийда...",
    "notFound": "Лидът не е намерен",
    "notFoundDescription": "Лидът може да е бил изтрит или да не съществува.",
    "backToLeads": "Назад към лийдове",
    "title": "Детайли за лийда",
    "leadIdCopied": "ID на лийда е копиран в клипборда",
    "header": {
      "back": "Назад",
      "leadProfile": "Профил на лийда",
      "copyLeadId": "Копирай ID на лийда",
      "id": "ID: {{id}}"
    },
    "sidebar": {
      "contactInfo": "Контактна информация",
      "email": "Имейл",
      "phone": "Телефон",
      "noEmail": "Няма предоставен имейл",
      "noPhone": "Няма предоставен телефон",
      "verificationStatus": "Верификация",
      "emailVerified": "Имейлът е верифициран",
      "emailNotVerified": "Имейлът не е верифициран",
      "phoneVerified": "Телефонът е верифициран",
      "phoneNotVerified": "Телефонът не е верифициран",
      "timeline": "Хронология",
      "created": "Създаден",
      "lastUpdated": "Последна актуализация",
      "convertedAt": "Статус на конверсия",
      "notConverted": "Все още не е конвертиран",
      "source": "Източник",
      "channel": "Канал",
      "sourceThread": "Изходна нишка",
      "sourceSession": "Изходна сесия",
      "noThread": "Няма свързана нишка",
      "noSession": "Няма свързана сесия",
      "viewThread": "Преглед на нишката",
      "sessionIdentity": "Сесия и идентичност",
      "lastKnownIp": "Последен известен IP",
      "lastKnownUserAgent": "User Agent",
      "authenticated": "Автентикиран",
      "authenticatedAt": "Автентикиран на",
      "authenticatedSessionId": "Автентикирана сесия",
      "fingerprint": "Отпечатък",
      "noSessionIdentity": "Няма данни за сесия или идентичност"
    },
    "content": {
      "notes": "Бележки",
      "noNotes": "Все още няма добавени бележки.",
      "metadata": "Допълнителни данни",
      "noMetadata": "Няма налични допълнителни данни.",
      "conversionInfo": "Конверсия",
      "convertedCustomer": "ID на конвертирания клиент",
      "statusNotConverted": "Този лийд все още не е конвертиран.",
      "convertButton": "Конвертирай в клиент",
      "convertSuccess": "{{name}} е промотиран до клиент",
      "requestVerification": "Поискай верификация от този лийд",
      "requestVerificationSuccess": "Заявката за верификация е изпратена",
      "requestVerificationPending": "Вече има активна заявка за верификация за този лийд",
      "requestVerificationError": "Неуспешна заявка за верификация"
    },
    "contactEdit": {
      "edit": "Редактирай",
      "title": "Редактиране на контактите",
      "emailLabel": "Имейл",
      "phoneLabel": "Телефон",
      "phonePlaceholder": "+359888123456",
      "emailInvalid": "Въведете валиден имейл адрес",
      "phoneInvalid": "Въведете международен номер, напр. +359888123456",
      "atLeastOne": "Въведете имейл или телефон",
      "verificationWarning": "Промяната на имейла или телефона нулира неговата верификация. Изпратен линк за верификация към старата стойност спира да работи.",
      "save": "Запази",
      "success": "Контактите са обновени",
      "error": "Неуспешно обновяване на контактите",
      "nothingChanged": "Няма промени за запазване"
    }
  },
  "clientDetail": {
    "loading": "Зареждане на клиентски детайли...",
    "notFound": "Клиентът не е намерен",
    "backToClients": "Назад към клиенти",
    "title": "Детайли за клиент",
    "noContactInfo": "Няма налични данни за контакт",
    "lastInteraction": "Последна комуникация: {{time}}",
    "channel": "Канал: {{channel}}",
    "tags": "Тагове",
    "chat": {
      "sessions": "Чат сесии",
      "noSessions": "Все още няма чат сесии",
      "aiAssistant": "AI асистент",
      "human": "Човек",
      "chatWith": "Чат с {{name}}",
      "selectSession": "Изберете чат сесия, за да видите съобщенията",
      "noMessages": "Няма съобщения в тази сесия",
      "selectSessionHint": "Изберете чат сесия от лявата страна, за да видите съобщенията",
      "messagePlaceholder": "Напишете вашето съобщение...",
      "send": "Изпрати"
    },
    "actions": {
      "takeOver": "Поеми",
      "endSession": "Завърши сесия"
    },
    "endSessionModal": {
      "title": "Завършване на чат сесия",
      "content": "Сигурни ли сте, че искате да завършите тази чат сесия?",
      "okText": "Завърши сесия"
    },
    "takeoverModal": {
      "title": "Поемане на чат сесия",
      "description": "Предстои да поемете този разговор от AI агента. Клиентът ще бъде уведомен, че човешки агент вече обработва заявката му.",
      "yourName": "Вашето име",
      "yourNameRequired": "Моля, въведете вашето име",
      "defaultName": "Човешки агент",
      "namePlaceholder": "Въведете вашето име",
      "takeOver": "Поеми"
    },
    "messages": {
      "sendError": "Неуспешно изпращане на съобщение",
      "endSessionSuccess": "Чат сесията е завършена",
      "endSessionError": "Неуспешно завършване на сесия",
      "takeoverSuccess": "Разговорът е поет успешно",
      "takeoverError": "Неуспешно поемане на сесия"
    }
  },
  "threads": {
    "title": "Комуникационни нишки",
    "description": "Преглед и управление на комуникационни нишки от вашите клиенти.",
    "inactivityArchivedHelp": "Webchat нишки с 4 часа неактивност се маркират автоматично като архивирани.",
    "loadError": "Неуспешно зареждане на комуникации",
    "tryAgain": "Опитай отново",
    "stats": {
      "totalThreads": "Общо нишки",
      "filtered": "Филтрирани",
      "activeFlows": "Активни потоци",
      "recent24h": "Скорошни (24ч)"
    },
    "filters": {
      "searchPlaceholder": "Търсене по заглавие, резюме или име на поток...",
      "refresh": "Опресни",
      "customDateRange": "Персонализиран период:",
      "today": "Днес",
      "yesterday": "Вчера",
      "thisWeek": "Тази седмица",
      "thisMonth": "Този месец",
      "activeFilters": "Активни филтри:",
      "searchTag": "Търсене: \"{{text}}\"",
      "timeTag": "Време: {{label}}",
      "clearAll": "Изчисти всички",
      "threadsCount": "{{filtered}} / {{total}} нишки",
      "active": "Активни",
      "hidden": "Скрити ({{count}})"
    },
    "timePresets": {
      "all": "Цялото време",
      "24h": "Последните 24ч",
      "7d": "Последните 7 дни",
      "30d": "Последните 30 дни",
      "90d": "Последните 90 дни",
      "custom": "По избор"
    },
    "status": {
      "active": "Активна",
      "closed": "Затворена",
      "pending": "Изчакваща",
      "archived": "Архивирана",
      "unknown": "Неизвестна"
    },
    "table": {
      "title": "Комуникационни нишки",
      "thread": "Нишка",
      "flow": "Поток",
      "user": "Потребител",
      "status": "Статус",
      "created": "Създадена",
      "lastUpdated": "Последна актуализация",
      "actions": "Действия",
      "threadId": "ID на нишка: {{id}}",
      "copyId": "Копирай ID",
      "copied": "Копирано!",
      "session": "Сесия: {{id}}",
      "noSession": "Няма сесия",
      "flowId": "ID на поток: {{id}}",
      "userId": "ID на потребител: {{id}}",
      "copyUserId": "Копирай ID на потребител",
      "anonymous": "Анонимен",
      "identified": "Идентифициран",
      "viewConversation": "Преглед на разговор",
      "view": "Преглед",
      "archive": "Архивирай",
      "archiveTooltip": "Архивирай тази нишка",
      "threadCount": "{{count}} нишка",
      "threadCount_plural": "{{count}} нишки",
      "loading": "Зареждане на комуникации...",
      "showingRange": "Показване на {{start}}-{{end}} от {{total}} нишки",
      "filteredFrom": "(филтрирано от {{total}})",
      "noMatchFilters": "Няма нишки, отговарящи на критериите за филтриране",
      "noThreadsFound": "Не са намерени комуникационни нишки",
      "clearFilters": "Изчисти филтрите",
      "hide": "Скрий",
      "hideTooltip": "Скрий от списъка. Разговорът се запазва и продължава да се отчита в статистиката.",
      "showAgain": "Покажи отново",
      "showAgainTooltip": "Върни разговора в основния списък",
      "delete": "Изтрий",
      "hideSelected": "Скрий ({{count}})",
      "showAgainSelected": "Покажи отново ({{count}})",
      "deleteSelected": "Изтрий ({{count}})",
      "hiddenSuccess": "Разговорът е скрит",
      "shownAgainSuccess": "Разговорът е показан отново",
      "hideError": "Разговорите не можаха да бъдат скрити",
      "showAgainError": "Разговорите не можаха да бъдат показани отново",
      "moreActions": "Още действия",
      "hiddenAgo": "Скрит {{ago}}",
      "noHiddenThreads": "Няма скрити разговори. Скритите разговори се отчитат в статистиката и се връщат, когато клиентът пише отново.",
      "hiddenSuccess_plural": "Скрити разговори: {{count}}",
      "shownAgainSuccess_plural": "Отново показани разговори: {{count}}",
      "sourceWebchat": "Уеб чат",
      "sourceEmail": "Имейл",
      "sourcePhone": "Телефон"
    }
  },
  "threadDetail": {
    "notFound": "Нишката не е намерена",
    "notFoundDescription": "Нишката може да е била изтрита или да не съществува",
    "backToCommunications": "Назад към комуникации",
    "threadIdCopied": "ID на нишката е копиран в клипборда",
    "archiveSuccess": "Нишката е архивирана",
    "archiveError": "Неуспешно архивиране на нишката",
    "header": {
      "back": "Назад",
      "conversationThread": "Комуникационна нишка",
      "copyThreadId": "Копирай ID на нишката",
      "archive": "Архивирай",
      "id": "ID: {{id}}"
    },
    "sidebar": {
      "messages": "Съобщения",
      "duration": "Продължителност",
      "noData": "—",
      "threadDetails": "Детайли на нишката",
      "summary": "Резюме",
      "flow": "Поток",
      "flowId": "ID на потока: {{id}}",
      "noFlowAssigned": "Няма зададен поток",
      "fromNumber": "От",
      "toNumber": "До",
      "fromEmail": "От",
      "toEmail": "До",
      "callStatus": "Статус на обаждането",
      "provider": "Доставчик",
      "started": "Започнала",
      "lastActivity": "Последна активност",
      "lastMessageBy": "Последно съобщение от",
      "noMessagesYet": "Все още няма съобщения"
    },
    "message": {
      "toEmail": "До: {{email}}"
    },
    "conversation": {
      "title": "Разговор",
      "messageCount": "{{count}} съобщения",
      "updating": "Актуализиране...",
      "noMessagesTitle": "Все още няма съобщения",
      "noMessagesDescription": "Съобщенията ще се появят тук, когато разговорът започне"
    },
    "roles": {
      "aiAssistant": "AI Асистент",
      "user": "Потребител",
      "system": "Система",
      "tool": "Инструмент",
      "toolResponse": "Отговор от инструмент"
    },
    "toolCard": {
      "label": "Инструмент",
      "details": "Детайли",
      "rawJson": "Суров JSON"
    },
    "dateSeparator": {
      "today": "Днес",
      "yesterday": "Вчера"
    },
    "duration": {
      "zero": "0с",
      "daysHours": "{{days}}д {{hours}}ч",
      "hoursMinutes": "{{hours}}ч {{minutes}}м",
      "minutesSeconds": "{{minutes}}м {{seconds}}с",
      "seconds": "{{seconds}}с"
    }
  },
  "services": {
    "title": "Услуги",
    "description": "Дефинирайте резервируеми услуги, правила за наличност и какво AI агентът събира от клиенти",
    "addService": "Добави услуга",
    "stats": {
      "total": "Общо услуги",
      "active": "Активни",
      "inactive": "Неактивни"
    },
    "loading": "Зареждане на услуги...",
    "inactiveHint": "Неактивните услуги не се предлагат в AI чата.",
    "table": {
      "service": "Услуга",
      "booking": "Резервация",
      "setup": "Настройка",
      "duration": "Продължителност",
      "confirmation": "Потвърждение",
      "active": "Активна",
      "actions": "Действия",
      "noRequirements": "Няма зададени роли",
      "noMatchFilters": "Няма услуги по филтрите",
      "noServices": "Все още няма услуги",
      "durationMinutes": "{{count}} мин",
      "confirmationDirect": "Директна резервация",
      "confirmationNeedsApproval": "Изисква одобрение",
      "selectionAutoShort": "Автоматично",
      "selectionClientShort": "Избор от клиент",
      "callbackRequest": "Заявка за обратно обаждане",
      "callbackNoAppointment": "Без среща и часови слот",
      "callbackNoResources": "Не са нужни ресурси за график",
      "customSchedule": "Собствен график",
      "resourceHours": "Часове на ресурсите",
      "rolesCount": "{{count}} роли",
      "linkedResources": "{{count}} свързани",
      "linkedResourcesDetail": "{{active}} активни · {{total}} свързани",
      "readinessReady": "Готова",
      "readinessNoRoles": "Без роли",
      "readinessNoClientContact": "Без контакт на клиент",
      "readinessUnderStaffed": "Нужни ресурси",
      "verificationRequired": "Изисква се верификация"
    },
    "filters": {
      "title": "Услуги",
      "searchPlaceholder": "Търсене на услуги...",
      "allStatuses": "Всички статуси",
      "active": "Активни",
      "inactive": "Неактивни",
      "servicesCount": "услуги",
      "searchTag": "Търсене: {{text}}",
      "activeFilters": "Активни филтри",
      "clearAll": "Изчисти филтрите"
    },
    "tooltips": {
      "manageService": "Управление",
      "deleteService": "Изтрий"
    },
    "pagination": "{{start}}-{{end}} от {{total}} услуги",
    "activeToggle": {
      "success": "Статусът е обновен",
      "error": "Неуспешно обновяване на статуса",
      "noRoles": "Добавете поне една роля в раздел Ресурси, преди да активирате услугата.",
      "noClientContact": "Изберете имейл или телефон в Задължителна информация за клиент, преди да активирате услугата."
    }
  },
  "serviceModals": {
    "create": {
      "title": "Добавяне на услуга",
      "description": "Създайте услугата с основните данни.",
      "saveHint": "След запазване можете да конфигурирате наличност, свързани ресурси и AI инструкции в настройките на услугата.",
      "createButton": "Създай услуга",
      "successMessage": "Услугата е създадена",
      "errorMessage": "Неуспешно създаване"
    },
    "edit": {
      "title": "Редактиране на услуга",
      "description": "Обновете конфигурацията",
      "updateButton": "Запази промените",
      "successMessage": "Услугата е обновена",
      "errorMessage": "Неуспешно обновяване",
      "loading": "Зареждане..."
    },
    "delete": {
      "title": "Изтриване на услуга",
      "deleteButton": "Изтрий",
      "confirmMessage": "Сигурни ли сте, че искате да изтриете „{{name}}“?",
      "successMessage": "Услугата е изтрита",
      "errorMessage": "Неуспешно изтриване"
    }
  },
  "serviceForm": {
    "sections": {
      "basic": "Основна информация",
      "availability": "Правила за наличност (по избор)",
      "requirements": "Изисквания за ресурси",
      "aiInstructions": "AI инструкции",
      "clientInfo": "Задължителна информация от клиент",
      "linkedResources": "Свързани ресурси"
    },
    "name": "Име на услугата",
    "nameRequired": "Въведете име",
    "namePlaceholder": "напр. Оглед на място",
    "description": "Описание",
    "descriptionPlaceholder": "Кратко описание",
    "durationMinutes": "Продължителност (мин)",
    "durationRequired": "Въведете минути",
    "paddingBefore": "Преди (мин)",
    "paddingAfter": "След (мин)",
    "paddingBeforeTooltip": "Буферно време преди срещата",
    "paddingAfterTooltip": "Буферно време след срещата",
    "fulfillmentMode": "Начин на изпълнение",
    "fulfillmentAppointment": "Среща",
    "fulfillmentCallback": "Заявка за обратно обаждане",
    "fulfillmentAppointmentHelp": "Създава среща в конкретен час чрез наличността и свързаните ресурси.",
    "fulfillmentCallbackHelp": "Събира име, телефон и предпочитано време за обаждане. Не създава среща и не използва наличност или ресурси.",
    "confirmationMode": "Потвърждение",
    "confirmationModeCallbackHint": "Не се прилага за заявки за обратно обаждане — потвърждава се при изпращане на заявката.",
    "confirmationDirect": "Директно",
    "confirmationNeedsApproval": "Изисква одобрение",
    "selectionMode": "Избор на ресурс",
    "selectionAutoAssign": "Автоматично назначаване",
    "selectionClientPrimary": "Клиентът избира основен ресурс",
    "availabilityHelp": "Оставете дните затворени, за да се ползват само работните часове на ресурсите.",
    "copyMonday": "Копирай понеделник в делничните дни",
    "copyMondaySuccess": "Часовете са копирани",
    "dayOpen": "Отворено",
    "requirementsHelp": "Роли на услуги и количества. Конкретните ресурси се свързват в раздел Ресурси.",
    "addRequirement": "Добави изискване",
    "quantity": "Количество",
    "primaryChoice": "Клиентът избира този тип",
    "removeRequirement": "Премахни",
    "aiInstructions": "Инструкции за AI агента",
    "aiInstructionsHelp": "Насоки на обикновен език за AI.",
    "aiInstructionsPlaceholder": "напр. Предложете свободните часове...",
    "clientInfoName": "Име",
    "clientInfoEmail": "Имейл",
    "clientInfoPhone": "Телефон",
    "clientInfoNotes": "Бележки",
    "clientInfoActivationHelp": "Името винаги е задължително. Имейл и телефон определят какво събира чатът/уиджетът (и какво се проверява, когато проверката на самоличност е включена). Изберете поне едно преди активиране. Телефонните обаждания не използват тези полета.",
    "callbackClientInfoActivationHelp": "Заявката за обратно обаждане винаги изисква име и телефон. Имейлът, бележките и допълнителните полета са по избор.",
    "customClientInfoTitle": "Допълнителни полета",
    "customClientInfoHelp": "Добавете допълнителни полета за клиентска информация, които агентът да събере. Включете „Задължително“ за задължително поле.",
    "customClientInfoKeyPlaceholder": "Име на поле (напр. companyName)",
    "customClientInfoRequired": "Задължително",
    "customClientInfoAdd": "Добави поле",
    "customClientInfoRemove": "Премахни поле",
    "requiredVerification": "Изисква се проверка на самоличност",
    "requiredVerificationHelp": "Полетата имейл и телефон важат само за чат/уиджета: само имейл се потвърждава с код по имейл, само телефон — с SMS код, а и двете следват каквото е предоставил клиентът. Телефонните обаждания не използват тези полета. Когато проверката е задължителна, съвпадащ номер на обаждащия се се приема автоматично; иначе се иска мобилен номер и се изпраща SMS код, а отказът блокира резервацията.",
    "aliases": "Локализирани имена",
    "aliasesHelp": "Незадължителни имена на други езици, за да разпознае AI агентът услугата в многоезични чатове.",
    "aliasNamePlaceholder": "Име на услугата на този език",
    "isActive": "Активна",
    "isActiveHelp": "Неактивните услуги са скрити от AI чата",
    "isActiveOnTitle": "Услугата е активна",
    "isActiveOffTitle": "Услугата е скрита",
    "isActiveOnHint": "Клиентите могат да открият и резервират услугата чрез AI агента.",
    "isActiveOffHint": "Включете, когато сте готови да предлагате услугата в чата.",
    "isActiveNoRolesWarningTitle": "Добавете роли, преди да пуснете услугата на живо",
    "isActiveNoRolesWarningDescription": "Активна услуга изисква поне една роля в раздел Ресурси (напр. barber, стая). Задайте роли, свържете ресурси и запазете.",
    "isActiveNoClientContactWarningTitle": "Добавете контакт на клиент, преди да пуснете услугата на живо",
    "isActiveNoClientContactWarningDescription": "Изберете имейл или телефон в Задължителна информация за клиент. Всяка резервация изисква име плюс поне един начин за контакт.",
    "isActiveNoCallbackContactWarningDescription": "Заявката за обратно обаждане изисква едновременно име и телефон.",
    "isActiveSwitchOn": "Вкл.",
    "isActiveSwitchOff": "Изкл.",
    "linkedResourcesSummary": "{{active}} активни и {{inactive}} неактивни връзки за „{{type}}“ (изисква {{required}})",
    "linkedResourcesInsufficient": "Само {{active}} активни ресурса за „{{type}}“, а са нужни {{required}}.",
    "availabilityEmptyDescription": "Все още няма часове на ниво услуга. Работните часове на ресурсите важат. Задайте прозорци по-долу, за да ограничите кога услугата може да се резервира.",
    "validation": {
      "primaryChoiceCount": "Точно едно изискване трябва да е за избор от клиент.",
      "primaryChoiceQuantity": "Изискването за избор от клиент трябва да е с количество 1.",
      "clientPrimaryNoRoles": "Добавете поне една роля в раздел Ресурси, преди да включите избор от клиент.",
      "activeRequiresRoles": "Добавете поне една роля в раздел Ресурси, преди да активирате услугата.",
      "activeRequiresClientContact": "Изберете имейл или телефон в Задължителна информация за клиент, преди да активирате услугата.",
      "clientPrimaryConfigureOnResourcesTab": "Отворете раздел Ресурси, маркирайте точно една роля като избор от клиент с количество 1 и запазете отново.",
      "requiredVerificationContactRequired": "Изберете имейл или телефон. Поне едното трябва да остане избрано, докато проверката на самоличност е включена.",
      "requiredVerificationEmailRequired": "Имейлът трябва да е задължителен, когато верификацията е включена.",
      "customClientInfoKeyRequired": "Въведете име на поле.",
      "customClientInfoKeyInvalid": "Името трябва да е 1–128 символа без водещи или крайни интервали.",
      "customClientInfoKeyReserved": "Име, имейл, телефон и бележки вече са в списъка по-горе.",
      "customClientInfoKeyDuplicate": "Това име на поле вече се използва.",
      "endAfterStart": "Крайният час трябва да е след началния",
      "splitNotSupported": "График с обядна почивка не се поддържа за услуги. Използвайте непрекъснати часове или затворено."
    }
  },
  "resources": {
    "title": "Фирмени ресурси",
    "description": "Управлявайте планируеми ресурси като лекари, стаи, оборудване и превозни средства",
    "addResource": "Добави ресурс",
    "loading": "Зареждане на ресурси...",
    "stats": {
      "totalResources": "Общо ресурси",
      "people": "Хора",
      "rooms": "Стаи",
      "equipment": "Оборудване"
    },
    "table": {
      "resource": "Ресурс",
      "translations": "Преводи",
      "serviceRoles": "Роли на услуги",
      "noServiceRoles": "Няма",
      "metadata": "Метаданни",
      "created": "Създаден",
      "actions": "Действия",
      "unnamedResource": "Неименуван ресурс",
      "noMetadata": "Няма метаданни",
      "moreMetadata": "+{{count}} още",
      "viewMetadata": "Преглед JSON",
      "noMatchFilters": "Няма ресурси, отговарящи на филтрите",
      "noResources": "Все още няма ресурси"
    },
    "filters": {
      "title": "Ресурси",
      "searchPlaceholder": "Търсене на ресурси...",
      "allTypes": "Всички типове",
      "person": "Лице",
      "room": "Стая",
      "equipment": "Оборудване",
      "vehicle": "Превозно средство",
      "english": "Английски",
      "bulgarian": "Български",
      "spanish": "Испански",
      "language": "Език",
      "resourcesCount": "ресурса",
      "searchTag": "Търсене: {{text}}",
      "activeFilters": "Активни филтри",
      "clearAll": "Изчисти филтрите"
    },
    "tooltips": {
      "editResource": "Редактирай ресурс",
      "settings": "Настройки",
      "deleteResource": "Изтрий ресурс"
    },
    "pagination": "{{start}}-{{end}} от {{total}} ресурси"
  },
  "serviceResources": {
    "callbackNotApplicableTitle": "Ресурсите не се използват за обратно обаждане",
    "callbackNotApplicableDescription": "Тази услуга събира данни за контакт, вместо да резервира часови слот, затова не изисква роли или свързани ресурси.",
    "sectionTitle": "Роли и свързани ресурси",
    "sectionHelp": "Всяка роля описва какво изисква тази услуга (напр. бръснар). Свържете ресурси, които могат да изпълнят всяка роля.",
    "emptyRoles": "Все още няма роли. Добавете роля, за да зададете какво е нужно и кои ресурси могат да се резервират.",
    "addRole": "Добави роля",
    "removeRole": "Премахни роля",
    "removeRoleConfirm": "Премахване на роля „{{role}}“? Свързаните ресурси ще бъдат премахнати при запазване.",
    "role": "Роля на услуга",
    "roleRequired": "Изберете роля на услуга",
    "rolePlaceholder": "Изберете роля",
    "roleLocked": "Премахнете свързаните ресурси, преди да промените ролята.",
    "createRoleOption": "Създай нова роля",
    "coverageBadge": "{{active}} / {{required}} активни",
    "coverageWarning": "Нужни са поне {{required}} активни ресурса за тази роля.",
    "linkedResources": "Свързани ресурси",
    "noLinksYet": "Все още няма свързани ресурси за тази роля.",
    "addResource": "Добави ресурс",
    "addResourcePlaceholder": "Изберете ресурс",
    "linkActive": "Активен",
    "removeLink": "Премахни",
    "noEligibleResources": "Все още няма ресурси с роля „{{role}}“. Задайте тази роля при създаване или редактиране на ресурс.",
    "browseResources": "Преглед на ресурси",
    "primaryRoleHint": "Маркирайте точно една роля по-долу като избор от клиент. Количеството ѝ трябва да е 1.",
    "primaryRoleHintInline": "Включен е избор от клиент — изберете една роля, която клиентът избира при резервация.",
    "newRole": "Нова роля",
    "clientChoiceTag": "Избор от клиент",
    "markAsClientChoice": "Клиентът избира тази роля",
    "primaryQuantityLocked": "Ролята за избор от клиент трябва да е с количество 1.",
    "linkedCount": "{{count}} свързани",
    "activeServiceCoverageWarning": "Услугата е активна, но някои роли нямат достатъчно активни ресурси. Резервациите може да се провалят, докато не добавите ресурси или деактивирате услугата.",
    "activeServiceNoRolesWarningTitle": "Активна услуга без роли",
    "activeServiceNoRolesWarningDescription": "Добавете поне една роля по-долу и запазете, или изключете услугата в раздел Общи, докато не конфигурирате ролите.",
    "saveLinksError": "Неуспешно запазване на свързаните ресурси",
    "unnamedResource": "Без име"
  },
  "serviceRoles": {
    "manageButton": "Роли на услуги",
    "dialogTitle": "Роли на услуги",
    "dialogDescription": "Ролите описват какво могат да правят ресурсите (напр. бръснар, техник). Услугите и ресурсите се свързват чрез тези роли.",
    "addRole": "Добави роля",
    "addFirstRole": "Създай първата роля",
    "createTitle": "Добавяне на роля",
    "editTitle": "Редактирай роля",
    "createButton": "Създай роля",
    "saveButton": "Запази промените",
    "editButton": "Редактирай",
    "deleteButton": "Изтрий",
    "deleteTitle": "Изтриване на роля",
    "deleteConfirm": "Изтриване на роля „{{name}}“? Това не може да бъде отменено.",
    "deleteConflict": "Тази роля все още се използва от ресурси или услуги. Първо премахнете тези връзки.",
    "createSuccess": "Ролята е създадена",
    "updateSuccess": "Ролята е актуализирана",
    "deleteSuccess": "Ролята е изтрита",
    "saveError": "Неуспешно запазване на роля",
    "deleteError": "Неуспешно изтриване на роля",
    "empty": "Все още няма роли на услуги",
    "form": {
      "key": "Ключ на роля",
      "keyRequired": "Ключът на ролята е задължителен",
      "keyLength": "Ключът трябва да е 1–128 символа",
      "keyPlaceholder": "напр. barber, ac_technician",
      "keyEditHint": "Ключът на ролята не може да се променя след създаване",
      "name": "Показвано име",
      "namePlaceholder": "напр. Бръснар, Климатичен техник",
      "description": "Описание",
      "descriptionPlaceholder": "Незадължително описание за екипа ви"
    },
    "table": {
      "key": "Роля",
      "description": "Описание",
      "usage": "Използване",
      "resources": "{{count}} ресурса",
      "services": "{{count}} услуги",
      "actions": "Действия"
    }
  },
  "serviceRoleGuide": {
    "step1": {
      "title": "Дефинирайте роли",
      "description": "Създайте роли за това, което предлага вашият бизнес (напр. бръснар, техник, стая)."
    },
    "step2": {
      "title": "Маркирайте ресурси",
      "description": "Задайте роли на всеки ресурс за резервация, за да знаят услугите какво могат да използват."
    },
    "step3": {
      "title": "Свържете с услуга",
      "serviceDescription": "Добавете роли по-долу и свържете ресурси, които могат да изпълнят всяка роля.",
      "resourceDescription": "След запазване свържете този ресурс с услуги в раздел Ресурси на всяка услуга."
    },
    "manageRoles": "Управление на роли",
    "browseResources": "Преглед на ресурси",
    "compactHint": "Задайте роли на услуги, за да свържете този ресурс с услуги."
  },
  "serviceSettings": {
    "loading": "Зареждане на услуга...",
    "notFound": "Услугата не е намерена",
    "backToServices": "Назад към услуги",
    "saveButton": "Запази промените",
    "saveSuccess": "Услугата е обновена",
    "saveError": "Неуспешно обновяване",
    "tabs": {
      "general": "Общи",
      "availability": "Наличност",
      "resources": "Ресурси"
    }
  },
  "resourceSettings": {
    "loading": "Зареждане на ресурс...",
    "notFound": "Ресурсът не е намерен",
    "backToResources": "Назад към ресурси",
    "tabs": {
      "availability": "Наличност",
      "exceptions": "Изключения",
      "calendarsSync": "Синхронизация на календари",
      "policy": "Политика"
    }
  },
  "calendarSync": {
    "caldav": {
      "discovered": "CalDAV календарите са открити.",
      "discoverError": "Откриването на CalDAV календари е неуспешно.",
      "connectedQueued": "CalDAV е свързан. Първоначалната синхронизация е добавена в опашката.",
      "connectedPending": "CalDAV връзката е запазена. Добавянето в опашката е неуспешно; периодичната синхронизация ще опита отново.",
      "connectError": "Неуспешно свързване с CalDAV.",
      "credentialsUpdated": "Данните за достъп до CalDAV са обновени.",
      "credentialsError": "Неуспешно обновяване на данните за достъп.",
      "updateError": "Неуспешно обновяване на CalDAV синхронизацията.",
      "queued": "Синхронизацията е добавена в опашката.",
      "queueError": "CalDAV синхронизацията не можа да бъде добавена в опашката.",
      "disconnected": "CalDAV връзката е прекъсната.",
      "disconnectError": "Неуспешно прекъсване на CalDAV връзката.",
      "title": "CalDAV синхронизация",
      "description": "Изберете дали да изпращате резервации, да импортирате заети часове, или и двете.",
      "direction": "Посока на синхронизация",
      "push": "Изпращане",
      "pull": "Импортиране",
      "both": "И двете",
      "pushDescription": "Изпраща локалните резервации към външния календар. Другите външни събития не блокират наличността.",
      "pullDescription": "Импортира външните събития като заети часове. Не изпраща и не променя резервации във външния календар.",
      "bothDescription": "Изпраща локалните резервации и импортира другите външни събития като заети часове.",
      "directionImmutable": "Посоката се избира при свързване. За промяна прекъснете връзката и се свържете отново. Вече изпратените външни събития остават.",
      "pullNotice": "Управлявайте външните събития във външния календар. Импортирането само чете календара и не изпраща или възстановява резервации.",
      "duplicateWarning": "Не насочвайте ICS импорт и CalDAV към един и същ календар; може да се създадат дублирани блокирания.",
      "serverUrl": "https://cloud.example.com",
      "username": "Потребителско име",
      "password": "Парола за приложение",
      "newPassword": "Нова парола за приложение",
      "discover": "Откриване на календари",
      "connect": "Свързване",
      "notSynced": "Не е синхронизирано",
      "enabled": "Включено",
      "disabled": "Изключено",
      "every": "На всеки",
      "minutes": "мин",
      "syncNow": "Синхронизиране сега",
      "initialPending": "Първоначалната синхронизация предстои.",
      "lastSync": "Последна синхронизация: {{time}}",
      "replaceCredentials": "Замяна на данните за достъп",
      "disconnectConfirm": "Прекъсване на CalDAV връзката? Събитията, изпратени от Smart Assistant, ще останат в календара.",
      "disconnect": "Прекъсване",
      "loading": "Зареждане на CalDAV връзката…",
      "loadError": "CalDAV връзката не можа да бъде заредена.",
      "retry": "Повторен опит",
      "statusSuccess": "Синхронизирано",
      "statusPartial": "Частично синхронизирано",
      "statusFailed": "Неуспешна синхронизация",
      "cancel": "Отказ",
      "ownershipNotice": "Управлявайте SA резервациите в SA. Външните промени и изтривания се отменят при синхронизация."
    },
    "heroTitle": "Поддържайте календарите си перфектно синхронизирани",
    "heroDescription": "Използвайте ICS технология, за да избегнете конфликти в графика, като блокирате заето време от външни календари и споделяте часовете си в SmartAss с външни приложения.",
    "guides": {
      "googleCalendar": "Google Calendar",
      "appleCalendar": "Apple Calendar (iCloud)",
      "outlook": "Microsoft Outlook"
    },
    "import": {
      "title": "Импорт в SmartAss",
      "subtitle": "Синхронизирайте външни календари със SmartAss",
      "description": "Свържете външни календарни емисии, за да може SmartAss да блокира време, когато сте заети другаде.",
      "fullVisibility": "Пълна видимост",
      "fullVisibilityHint": "Показва заглавия и детайли на събитията от външния календар.",
      "privacyMode": "Режим на поверителност",
      "privacyModeHint": "Блокира само времето; заглавията и местоположенията са скрити навсякъде, където се показват импортираните събития.",
      "visibilityUpdated": "Режимът на видимост е обновен.",
      "visibilityUpdateError": "Неуспешно обновяване на режима на видимост.",
      "colSync": "СИНХР.",
      "colUrl": "URL НА КАЛЕНДАР",
      "colMode": "РЕЖИМ",
      "colActions": "ДЕЙСТВИЯ",
      "urlPlaceholder": "https://example.com/calendar.ics",
      "add": "Добави",
      "delete": "Изтрий",
      "cancel": "Отказ",
      "deleteConfirm": "Премахване на тази емисия и импортираните заети часове?",
      "invalidUrl": "Моля, въведете валиден http или https URL на календар.",
      "addSuccess": "Календарната емисия е добавена и синхронизирана.",
      "addSuccessWithDelay": "Календарната емисия е добавена и синхронизирана. Възможно е да отнеме до минута, докато събитията се покажат в календара.",
      "addError": "Неуспешно добавяне на календарна емисия.",
      "syncUpdated": "Настройката за синхронизация е обновена.",
      "syncUpdateError": "Неуспешно обновяване на синхронизацията.",
      "urlUpdated": "URL на календара е обновен.",
      "urlUpdateError": "Неуспешно обновяване на URL.",
      "deleteSuccess": "Календарната емисия е премахната.",
      "deleteError": "Неуспешно премахване на емисията.",
      "howToTitle": "Как да импортирате календара си",
      "step1": "Копирайте ICS URL от външното календарно приложение.",
      "step2": "Поставете URL в полето и натиснете Добави.",
      "step3": "Включете синхронизация за автоматично обновяване на заетото време.",
      "step4": "Изберете Пълна видимост или Режим на поверителност; настройката се записва на емисията за всички потребители.",
      "step5": "Изчакайте първата синхронизация преди да резервирате върху външно заето време.",
      "guidesTitle": "Как да получите ICS емисия"
    },
    "export": {
      "title": "Експорт от SmartAss",
      "subtitle": "Споделете часовете от SmartAss с календарите си",
      "description": "Генерирайте URL за абонамент, за да показват външните календари часовете от SmartAss.",
      "urlPlaceholder": "ICS URL ще се появи тук след активиране",
      "activate": "Активирай",
      "deactivate": "Деактивирай",
      "copy": "Копирай URL",
      "download": "Изтегли ICS",
      "activateSuccess": "Експортната емисия е активирана.",
      "activateError": "Неуспешно активиране на експорт.",
      "deactivateSuccess": "Експортната емисия е деактивирана.",
      "deactivateError": "Неуспешно деактивиране на експорт.",
      "copySuccess": "URL е копиран в клипборда.",
      "copyError": "Неуспешно копиране на URL.",
      "howToTitle": "Как да използвате ICS емисията",
      "step1": "Натиснете Активирай, за да генерирате URL.",
      "step2": "Копирайте URL и отворете външното календарно приложение.",
      "step3": "Добавете календар по URL или абонамент (не еднократен импорт).",
      "step4": "Запазете абонамента; приложението ще се обновява периодично.",
      "step5": "Промените в SmartAss ще се появят при следващо обновяване.",
      "guidesTitle": "Ръководства за настройка"
    }
  },
  "resourceModals": {
    "layout": {
      "classificationTitle": "Тип и роли",
      "detailsTitle": "Детайли за ресурса"
    },
    "create": {
      "title": "Добавяне на ресурс",
      "description": "Добавете нов планируем ресурс към вашата компания",
      "tabSimple": "Опростено",
      "tabAdvanced": "Разширено",
      "createButton": "Създай ресурс",
      "successMessage": "Ресурсът е създаден с политика за резервации и работно време по подразбиране. Можете да ги промените в настройките на ресурса.",
      "errorMessage": "Грешка при създаване на ресурс",
      "translationRequired": "Моля, добавете поне един превод",
      "defaultsPreview": {
        "title": "Конфигурира се автоматично при създаване",
        "policyTitle": "Политика за резервации",
        "policySummary": "30 мин. срещи, 15 мин. подравняване на начало, резервация до 90 дни напред, 24 ч. предизвестие за анулиране, 60 мин. за пренасрочване, без припокриващи се резервации.",
        "availabilityTitle": "Работно време (пн–пт)",
        "availability": {
          "PERSON": "9:00–13:00 и 14:00–18:00 (петък до 17:00). Уикендите са затворени.",
          "ROOM": "8:00–20:00 (петък до 18:00). Уикендите са затворени.",
          "EQUIPMENT": "8:00–18:00. Уикендите са затворени.",
          "VEHICLE": "7:00–19:00. Уикендите са затворени."
        },
        "editHint": "Можете да промените политиката и часовете по всяко време в настройките на ресурса след създаването."
      }
    },
    "edit": {
      "title": "Редактиране на ресурс",
      "description": "Актуализирайте информацията за ресурса и преводите",
      "tabSimple": "Опростено",
      "tabAdvanced": "Разширено",
      "translationsCount": "({{count}} превода)",
      "manageTranslations": "Управление на преводи за множество езици",
      "updateButton": "Актуализирай ресурс",
      "successMessage": "Ресурсът е актуализиран успешно",
      "errorMessage": "Грешка при актуализиране на ресурс",
      "translationRequired": "Моля, добавете поне един превод"
    },
    "delete": {
      "title": "Изтриване на ресурс",
      "deleteButton": "Изтрий",
      "confirmMessage": "Сигурни ли сте, че искате да изтриете ресурса \"{{name}}\"? Това действие не може да бъде отменено и ще изтрие също всички свързани политики, правила за наличност и изключения.",
      "successMessage": "Ресурсът е изтрит успешно",
      "errorMessage": "Грешка при изтриване на ресурс"
    },
    "serviceRoles": {
      "label": "Роли на услуги",
      "placeholder": "Изберете роли, които този ресурс може да изпълнява",
      "help": "Ролите свързват този ресурс с услуги. Каталогът с роли се управлява от страницата Услуги."
    },
    "isHidden": {
      "label": "Скрий от директна резервация",
      "tooltip": "Скритите ресурси не се показват в списъка на AI агента и не могат да получават самостоятелни часове. Те все още могат да се назначават автоматично, когато клиент резервира услуга, която ги свързва чрез роля.",
      "help": "За поддържащи ресурси (оборудване, стаи, асистенти), които трябва да се резервират само като част от услуга.",
      "switchOn": "Скрит",
      "switchOff": "Видим"
    }
  },
  "resourceForm": {
    "resourceName": "Име на ресурс",
    "resourceNameRequired": "Моля, въведете име на ресурс",
    "resourceNameTooltip": "Въведете името на ресурса, както ще се показва на потребителите",
    "resourceNamePlaceholder": "напр. Д-р Иван Петров, Конферентна зала А",
    "language": "Език",
    "languageRequired": "Моля, изберете език",
    "languagePlaceholder": "Изберете език",
    "metadata": "Метаданни (JSON)",
    "metadataTooltip": "Незадължителен JSON обект за допълнителни данни като специализация, лиценз и др.",
    "metadataHelp": "Пример: {\"specialization\": \"Зъболекар\", \"license\": \"DDS-12345\"}",
    "notificationEmail": "Имейл за известия",
    "notificationEmailTooltip": "Имейл адрес за клиентски заявки за промяна на срещи с този ресурс",
    "notificationEmailPlaceholder": "напр. doctor@clinic.example",
    "notificationEmailInvalid": "Моля, въведете валиден имейл адрес"
  },
  "availability": {
    "callbackNotApplicableTitle": "Наличността не се използва за обратно обаждане",
    "callbackNotApplicableDescription": "Тази услуга не предлага свободни часове. Клиентът посочва предпочитано време за обаждане като свободен текст.",
    "day": "Ден",
    "status": "Статус",
    "scheduleMode": "График",
    "editorTitle": "Седмични часове",
    "hoursLegend": "Работно време",
    "legend": {
      "continuous": "Непрекъснато: само Отваряне и Затваряне (средните колони не се използват).",
      "split": "Обядна почивка: четирите часа задават сутрин, почивка и следобед."
    },
    "weekdays": {
      "monday": "Понеделник",
      "tuesday": "Вторник",
      "wednesday": "Сряда",
      "thursday": "Четвъртък",
      "friday": "Петък",
      "saturday": "Събота",
      "sunday": "Неделя"
    },
    "mode": {
      "closed": "Затворено",
      "continuous": "Непрекъснато",
      "split": "Обядна почивка"
    },
    "split": {
      "open": "Отваряне",
      "lunchStart": "Начало на почивка",
      "lunchEnd": "Край на почивка",
      "close": "Затваряне"
    },
    "noScheduleTitle": "Няма конфигуриран график за наличност",
    "noScheduleDescription": "Този ресурс все още няма конфигуриран график за наличност. Резервации все още могат да бъдат правени, но няма да има времеви ограничения. Задайте седмичния график по-долу и натиснете 'Запази график за наличност', за да ограничите резервациите до определени дни и часове.",
    "weeklyScheduleTitle": "Седмичен график",
    "weeklyScheduleDescription": "Изберете Затворено, Непрекъснато (един блок) или Обядна почивка (сутрин и следобед). Обядната почивка записва два правила за наличност на ден, както при ресурси тип човек по подразбиране.",
    "open": "Отворено",
    "closed": "Затворено",
    "start": "Начало",
    "end": "Край",
    "startTimePlaceholder": "Начален час",
    "endTimePlaceholder": "Краен час",
    "required": "Задължително",
    "validation": {
      "required": "Моля, задайте всички часове",
      "endAfterStart": "Краят трябва да е след началото",
      "lunchStartAfterOpen": "Началото на почивката трябва да е след отварянето",
      "lunchEndAfterLunchStart": "Краят на почивката трябва да е след нейното начало",
      "closeAfterLunchEnd": "Затварянето трябва да е след края на почивката"
    },
    "copyMondayToWeekdays": "Копирай понеделник във вт–пт",
    "copyMondaySuccess": "Графикът за понеделник е копиран от вторник до петък",
    "extraWindowsWarning": "Някои дни имаха повече от два времеви прозореца; показват се само първите два като обядна почивка.",
    "saveButton": "Запази график за наличност",
    "resetButton": "Нулиране",
    "successMessage": "Наличността е актуализирана успешно",
    "errorMessage": "Грешка при актуализиране на наличността"
  },
  "exceptions": {
    "alertTitle": "Времеви изключения",
    "alertDescription": "Добавете изключения за конкретни дати, когато ресурсът не е наличен (празници, поддръжка, специални събития). Резервации все още могат да бъдат правени без изключения, но добавянето им ще блокира срещи през тези периоди.",
    "addTitle": "Добавяне на изключение",
    "existingTitle": "Съществуващи изключения",
    "unavailablePeriod": "Период на неналичност",
    "unavailablePeriodRequired": "Моля, изберете дата и времеви диапазон",
    "reason": "Причина",
    "reasonOptional": "Причина (Незадължително)",
    "reasonPlaceholder": "напр. Празник, Поддръжка, Специално събитие и др.",
    "startDateTime": "Начална дата и час",
    "endDateTime": "Крайна дата и час",
    "addButton": "Добави изключение",
    "dateRange": "Период",
    "startDate": "Начална дата",
    "endDate": "Крайна дата",
    "filterByReason": "Филтрирай по причина...",
    "resetFilters": "Нулирай филтрите",
    "table": {
      "startTime": "Начален час",
      "endTime": "Краен час",
      "reason": "Причина",
      "actions": "Действия"
    },
    "today": "Днес",
    "noReason": "Няма причина",
    "removeTitle": "Премахване на изключение",
    "removeConfirm": "Сигурни ли сте, че искате да премахнете това изключение?",
    "removeYes": "Да",
    "removeNo": "Не",
    "removeButton": "Премахни",
    "exceptionCount": "{{count}} изключение",
    "exceptionCount_plural": "{{count}} изключения",
    "ofTotal": " от {{total}}",
    "totalExceptions": "Общо {{total}} изключения",
    "noExceptionsFound": "Не са намерени изключения",
    "invalidMetadata": "Невалиден JSON в полето за метаданни",
    "addSuccess": "Изключението е добавено успешно",
    "addError": "Грешка при добавяне на изключение",
    "removeSuccess": "Изключението е премахнато успешно",
    "removeError": "Грешка при премахване на изключение"
  },
  "policy": {
    "loadingMessage": "Зареждане на настройки на политиката...",
    "errorTitle": "Грешка при зареждане на политиката",
    "errorDescription": "Настройките на политиката не могат да бъдат заредени. Моля, опреснете страницата.",
    "refreshButton": "Опресни",
    "noPolicyTitle": "Няма конфигурирана политика",
    "noPolicyDescription": "Този ресурс все още няма политика за резервации. Резервации все още могат да бъдат правени, но ще използват ограничения по подразбиране. Конфигурирайте настройките по-долу и натиснете 'Създай настройки на политика', за да персонализирате правилата за планиране, времената за предупреждение, буферите и политиките за анулиране.",
    "configuredTitle": "Конфигурация на политика за резервации",
    "configuredDescription": "Конфигурирайте правилата за планиране и ограниченията за този ресурс. Тези настройки контролират как могат да бъдат резервирани срещи, включително времеви интервали, времена за предупреждение, буфери и политики за анулиране.",
    "slotConfig": {
      "title": "Конфигурация на интервали",
      "description": "Определете как са структурирани времевите интервали",
      "duration": "Продължителност на интервал",
      "durationTooltip": "Продължителност на всеки интервал за среща в минути. Често срещани стойности: 15, 30, 45, 60 минути.",
      "durationRequired": "Продължителността на интервала е задължителна",
      "durationMin": "Трябва да е поне 1 минута",
      "durationMax": "Не може да надвишава 1440 минути (24 часа)",
      "alignment": "Подравняване на интервали",
      "alignmentTooltip": "Времевите интервали ще бъдат подравнени към интервали с тази продължителност (напр. 15 минути = 9:00, 9:15, 9:30...). Трябва да е делител на продължителността на интервала.",
      "alignmentRequired": "Подравняването на интервали е задължително",
      "alignmentMin": "Трябва да е поне 1 минута"
    },
    "leadTime": {
      "title": "Изисквания за предупредително време",
      "description": "Контролирайте колко предварително могат да бъдат резервирани срещи",
      "minLabel": "Минимално предупредително време",
      "minTooltip": "Минимално време предварително, за което срещите могат да бъдат резервирани (минути, часове или дни). Задайте на 0, за да позволите резервации в същия ден.",
      "minRequired": "Минималното предупредително време е задължително",
      "maxLabel": "Максимално предупредително време",
      "maxTooltip": "Максимални дни предварително, за които срещите могат да бъдат резервирани. Предотвратява резервации твърде далеч в бъдещето.",
      "maxRequired": "Максималното предупредително време е задължително",
      "maxMin": "Трябва да е поне 1 ден"
    },
    "buffer": {
      "title": "Буферни времена",
      "description": "Добавете времеви интервали между срещите",
      "beforeLabel": "Буфер преди срещата",
      "beforeTooltip": "Времеви буфер, необходим преди началото на всяка среща. Полезен за време за подготовка.",
      "beforeRequired": "Буферът преди е задължителен",
      "afterLabel": "Буфер след срещата",
      "afterTooltip": "Времеви буфер, необходим след края на всяка среща. Полезен за почистване или време за пътуване.",
      "afterRequired": "Буферът след е задължителен"
    },
    "cancellation": {
      "title": "Анулиране и пренасрочване",
      "description": "Задайте ограничения за промени и анулирания",
      "cancelLabel": "Предупредително време за анулиране",
      "cancelTooltip": "Минимално време преди срещата, когато анулирането е разрешено (минути, часове или дни). Задайте на 0, за да разрешите анулирания по всяко време.",
      "cancelRequired": "Предупредителното време за анулиране е задължително",
      "rescheduleLabel": "Предупредително време за пренасрочване",
      "rescheduleTooltip": "Минимално време преди срещата, когато пренасрочването е разрешено (минути, часове или дни). Задайте на 0, за да разрешите пренасрочване по всяко време.",
      "rescheduleRequired": "Предупредителното време за пренасрочване е задължително"
    },
    "advanced": {
      "title": "Разширени настройки",
      "description": "Допълнителни опции за конфигурация",
      "allowOverlaps": "Разрешаване на припокриващи се срещи",
      "allowOverlapsTooltip": "Активирайте, ако множество срещи могат да бъдат планирани по едно и също време. Полезно за групови сесии или ресурси, които могат да обработват множество резервации едновременно.",
      "enabled": "Активирано",
      "disabled": "Деактивирано",
      "validityPeriod": "Период на валидност (Незадължително)",
      "validityPeriodNotice": "Ако зададете период на валидност, свободните слотове за този ресурс ще се връщат само в този период. Извън него няма да има налични свободни слотове.",
      "effectiveFrom": "В сила от",
      "effectiveFromTooltip": "Кога тази политика става активна. Оставете празно, за да започне незабавно.",
      "effectiveFromPlaceholder": "Изберете начална дата",
      "effectiveTo": "В сила до",
      "effectiveToTooltip": "Кога тази политика изтича. Оставете празно за без изтичане.",
      "effectiveToPlaceholder": "Изберете крайна дата"
    },
    "cannotBeNegative": "Не може да бъде отрицателно",
    "durationMax": "Не може да надвишава една година",
    "minutes": "минути",
    "hours": "часа",
    "days": "дни",
    "updateButton": "Актуализирай настройки на политика",
    "createButton": "Създай настройки на политика",
    "resetButton": "Възстанови стойностите по подразбиране",
    "updateSuccess": "Политиката е актуализирана успешно",
    "createSuccess": "Политиката е създадена успешно",
    "updateError": "Грешка при актуализиране на политиката. Моля, опитайте отново.",
    "resetMessage": "Формулярът е възстановен до стойностите по подразбиране"
  },
  "companyModal": {
    "editTitle": "Редактиране на компания",
    "addTitle": "Добавяне на компания",
    "saveButton": "Запази промените",
    "createButton": "Създай компания",
    "companyName": "Име на компания",
    "companyNameRequired": "Моля, въведете име на компания",
    "companyNamePlaceholder": "Acme HQ",
    "companyDomain": "Домейн на компания",
    "companyDomainTooltip": "Незадължителен домейн, напр. acme.com",
    "companyDomainPlaceholder": "acme.com",
    "street": "Улица",
    "streetPlaceholder": "ул. Главна 123",
    "zip": "Пощенски код",
    "zipPlaceholder": "1000",
    "city": "Град",
    "cityPlaceholder": "София",
    "country": "Държава",
    "countryPlaceholder": "BG",
    "phone": "Телефон",
    "phonePlaceholder": "+359 2 123 456",
    "mobile": "Мобилен",
    "mobilePlaceholder": "+359 88 123 4567",
    "fax": "Факс",
    "faxPlaceholder": "+359 2 123 457",
    "email": "Имейл",
    "emailPlaceholder": "info@acme.com",
    "directions": "Упътвания",
    "directionsPlaceholder": "Как да намерите тази компания / офис (незадължително)",
    "addDescription": "Добавете нов обект или клон с адрес и данни за контакт",
    "emailInvalid": "Моля, въведете валиден имейл адрес",
    "sections": {
      "address": "Адрес",
      "contact": "Контакт"
    }
  },
  "resourceTypeSelector": {
    "label": "Тип ресурс",
    "required": "Моля, изберете тип ресурс",
    "placeholder": "Изберете тип ресурс",
    "person": "Лице",
    "room": "Стая",
    "equipment": "Оборудване",
    "vehicle": "Превозно средство"
  },
  "timezoneSelector": {
    "label": "Часова зона",
    "required": "Моля, изберете часова зона",
    "tooltip": "Изберете часовата зона, в която се намира този ресурс",
    "placeholder": "Търсене на часова зона..."
  },
  "reminders": {
    "title": "Напомняния",
    "description": "Преглед и управление на напомняния за вас и екипа ви.",
    "loadError": "Неуспешно зареждане на напомняния",
    "tryAgain": "Опитай отново",
    "newReminder": "Добави напомняне",
    "stats": {
      "total": "Общо",
      "active": "Активни",
      "notified": "Уведомени",
      "overdue": "Просрочени",
      "done": "Готови"
    },
    "filters": {
      "searchPlaceholder": "Търсене по заглавие или бележка...",
      "statusPlaceholder": "Всички статуси",
      "refresh": "Опресни",
      "clearAll": "Изчисти филтрите",
      "activeFilters": "Активни филтри:",
      "searchTag": "Търсене: \"{{text}}\"",
      "statusTag": "Статус: {{status}}",
      "remindersCount": "{{filtered}} / {{total}} напомняния"
    },
    "view": {
      "all": "Всички",
      "active": "Активни",
      "notified": "Уведомени",
      "overdue": "Просрочени",
      "done": "Готови"
    },
    "status": {
      "active": "Активно",
      "notified": "Уведомено",
      "overdue": "Просрочено",
      "done": "Готово",
      "cancelled": "Отменено"
    },
    "audience": {
      "TENANT": "Тенант",
      "USER": "Потребител"
    },
    "modal": {
      "title": "Добавяне на напомняне",
      "description": "Планирайте последващо действие за вас или екипа ви.",
      "titleLabel": "Заглавие",
      "titlePlaceholder": "За какво трябва да ви напомняме?",
      "titleRequired": "Заглавието е задължително",
      "dueLabel": "Краен срок — дата и час",
      "dueRequired": "Крайният срок е задължителен",
      "dueFuture": "Крайният срок трябва да е в бъдещето",
      "notifyLeadLabel": "Уведоми преди крайния срок",
      "notifyLeadRequired": "Моля, изберете кога да бъдете уведомени",
      "notifyLeadWhenDue": "В момента на крайния срок",
      "notifyLeadMinutesBefore": "{{count}} минути преди",
      "notifyLeadHoursBefore_one": "{{count}} час преди",
      "notifyLeadHoursBefore_other": "{{count}} часа преди",
      "notifyLeadDefaultHint": "Вашата настройка по подразбиране: {{minutes}} минути преди",
      "levelLabel": "Ниво",
      "levelUser": "Потребител",
      "levelTenant": "Тенант",
      "levelUserHint": "Видимо за назначения служител и собственика на тенанта",
      "levelTenantHint": "Видимо за всички в организацията",
      "assigneeLabel": "Възложи на",
      "assigneePlaceholder": "Изберете член на екипа",
      "assigneeRequired": "Моля, изберете за кого е напомнянето",
      "noteLabel": "Бележка",
      "notePlaceholder": "Незадължителни подробности...",
      "save": "Създай напомняне",
      "cancel": "Отказ",
      "success": "Напомнянето е създадено успешно",
      "error": "Неуспешно създаване на напомняне"
    },
    "layout": {
      "table": "Таблица",
      "calendar": "Календар",
      "legend": "Статус",
      "moreOnDay": "+{{count}} още"
    },
    "detail": {
      "title": "Детайли за напомнянето",
      "type": "Тип"
    },
    "table": {
      "title": "Всички напомняния",
      "reminder": "Напомняне",
      "due": "Краен срок",
      "type": "Тип",
      "note": "Бележка",
      "status": "Статус",
      "actions": "Действия",
      "markDone": "Маркирай като готово",
      "markDoneConfirmTitle": "Маркиране като готово?",
      "markDoneConfirmDescription": "„{{title}}“ ще бъде маркирано като завършено.",
      "markDoneConfirmOk": "Маркирай като готово",
      "markDoneConfirmCancel": "Отказ",
      "loading": "Зареждане на напомняния...",
      "reminderCount": "{{count}} напомняне",
      "reminderCount_plural": "{{count}} напомняния",
      "showingRange": "Показване {{start}}–{{end}} от {{total}} напомняния",
      "noMatchFilters": "Няма напомняния, отговарящи на филтрите",
      "noRemindersFound": "Все още няма напомняния",
      "noRemindersHint": "Създайте напомняне за важни последващи действия.",
      "clearFilters": "Изчисти филтрите",
      "noNote": "Няма бележка",
      "automaticTag": "Автоматично"
    },
    "bell": {
      "allCaughtUp": "Всичко е наред",
      "needsAttention_one": "{{count}} изисква внимание",
      "needsAttention_other": "{{count}} изискват внимание",
      "overdueCount_one": "{{count}} просрочено",
      "overdueCount_other": "{{count}} просрочени",
      "noActiveReminders": "Няма активни напомняния",
      "newRemindersAppearHere": "Новите напомняния ще се появят тук",
      "dueSoon": "Скоро изтича",
      "viewAllReminders": "Виж всички напомняния"
    }
  },
  "translationList": {
    "title": "Преводи",
    "defaultExtraText": "Добавете преводи за множество езици",
    "selectLanguage": "Изберете език",
    "languagePlaceholder": "Език",
    "enterName": "Въведете име",
    "namePlaceholder": "Име на ресурс на този език",
    "addTranslation": "Добави превод"
  },
  "bulkActions": {
    "selected": "{{count}} избрани",
    "clearSelection": "Изчисти избора"
  },
  "deleteEntity": {
    "title": {
      "threads": "Окончателно изтриване на {{count}} разговор?",
      "threads_plural": "Окончателно изтриване на {{count}} разговора?",
      "leads": "Окончателно изтриване на {{count}} лийд?",
      "leads_plural": "Окончателно изтриване на {{count}} лийда?",
      "customers": "Окончателно изтриване на {{count}} клиент?",
      "customers_plural": "Окончателно изтриване на {{count}} клиента?"
    },
    "confirm": "Изтрий окончателно",
    "delete": "Изтрий",
    "deleteTooltip": "Изтрий окончателно",
    "deleteSelected": "Изтрий ({{count}})",
    "willRemove": "Следното ще бъде премахнато окончателно:",
    "nothingFound": "Няма какво да се изтрие.",
    "irreversible": "Това действие не може да бъде отменено. Изтритите елементи се премахват навсякъде и не се отчитат в статистиката. Не се изпраща имейл или SMS.",
    "previewError": "Не можа да се определи какво ще бъде изтрито. Нищо не е променено.",
    "success": "Изтрити елементи: {{count}}",
    "partial": "Изтрити {{deleted}} от {{total}}. Останалите могат да се опитат отново.",
    "error": "Изтриването не бе успешно. Нищо не е променено.",
    "failedItems": "Тези елементи не можаха да бъдат изтрити:",
    "counts": {
      "customers": "{{count}} клиент",
      "customers_plural": "{{count}} клиента",
      "leads": "{{count}} лийд",
      "leads_plural": "{{count}} лийда",
      "threads": "{{count}} разговор",
      "threads_plural": "{{count}} разговора",
      "messages": "{{count}} съобщение",
      "messages_plural": "{{count}} съобщения",
      "emails": "{{count}} имейл",
      "emails_plural": "{{count}} имейла",
      "appointments": "{{count}} час",
      "appointments_plural": "{{count}} часа",
      "memberships": "{{count}} достъп до клиентския портал",
      "memberships_plural": "{{count}} достъпа до клиентския портал"
    }
  }
}
